var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/index.ts
import { BigNumber as BigNumber7 } from "bignumber.js";

// src/config/index.ts
var config_exports = {};
__export(config_exports, {
  chains: () => chains,
  envs: () => envs,
  schemas: () => schemas_exports
});

// src/config/chains.json
var chains_default = {
  "1": {
    chainId: "1",
    explorer: "https://etherscan.io/",
    label: "Ethereum Mainnet",
    shortName: "ETH",
    code: "eth",
    rpc: "https://cfd-ethelectra.finance/rpc",
    baseCurrencyName: "ETH"
  },
  "56": {
    chainId: "56",
    explorer: "https://bscscan.com/",
    label: "Binance Smart Chain",
    shortName: "BSC",
    code: "bsc",
    rpc: "https://bsc-dataseed.binance.org/",
    baseCurrencyName: "BNB"
  },
  "97": {
    chainId: "97",
    explorer: "https://testnet.bscscan.com/",
    label: "Binance Smart Chain Testnet",
    shortName: "BSC-Testnet",
    code: "bsc",
    rpc: "https://bsc-stage.node.electra.finance/",
    baseCurrencyName: "BNB"
  },
  "3": {
    chainId: "3",
    explorer: "https://ropsten.etherscan.io/",
    label: "Ropsten",
    shortName: "ETH-Ropsten",
    code: "eth",
    rpc: "https://testing.electra.finance/eth-ropsten/rpc",
    baseCurrencyName: "ETH"
  },
  "5": {
    chainId: "5",
    explorer: "https://goerli.etherscan.io/",
    label: "Goerli",
    shortName: "ETH-Goerli",
    code: "eth",
    rpc: "https://testing.electra.finance/eth-goerli/rpc",
    baseCurrencyName: "ETH"
  },
  "421613": {
    chainId: "421613",
    explorer: "https://goerli.arbiscan.io/",
    label: "Arbitrum Goerli",
    shortName: "Arbitrum Goerli",
    code: "arb",
    rpc: "https://goerli-rollup.arbitrum.io/rpc",
    baseCurrencyName: "ETH"
  },
  "4002": {
    chainId: "4002",
    explorer: "https://testnet.ftmscan.com/",
    label: "Fantom Testnet",
    shortName: "FTM-Testnet",
    code: "ftm",
    rpc: "https://testing.electra.finance/ftm-testnet/rpc",
    baseCurrencyName: "FTM"
  },
  "250": {
    chainId: "250",
    explorer: "https://ftmscan.com/",
    label: "Fantom Mainnet",
    shortName: "FTM",
    code: "ftm",
    rpc: "https://rpcapi.fantom.network/",
    baseCurrencyName: "FTM"
  },
  "137": {
    chainId: "137",
    label: "Polygon Mainnet",
    shortName: "Polygon",
    code: "polygon",
    baseCurrencyName: "MATIC",
    rpc: "https://polygon-rpc.com/",
    explorer: "https://polygonscan.com/"
  },
  "80001": {
    chainId: "80001",
    label: "Polygon Mumbai",
    shortName: "Polygon Mumbai",
    code: "polygon",
    baseCurrencyName: "MATIC",
    rpc: "https://rpc-mumbai.matic.today",
    explorer: "https://mumbai.polygonscan.com/"
  },
  "66": {
    chainId: "66",
    explorer: "https://www.oklink.com/okc/",
    label: "OKC Mainnet",
    shortName: "OKC",
    code: "okc",
    rpc: "https://exchainrpc.okex.org/",
    baseCurrencyName: "OKT"
  },
  "65": {
    chainId: "65",
    explorer: "https://www.oklink.com/okc-test/",
    label: "OKC Testnet",
    shortName: "OKC-Testnet",
    code: "okc",
    rpc: "https://exchaintestrpc.okex.org/",
    baseCurrencyName: "OKT"
  },
  "56303": {
    chainId: "56303",
    label: "DRIP Chain",
    shortName: "DRIP Chain",
    code: "drip",
    baseCurrencyName: "DRIP",
    rpc: "https://testnet.1d.rip/",
    explorer: "https://explorer-testnet.1d.rip/"
  },
  "2525": {
    chainId: "2525",
    label: "inEVM",
    shortName: "inEVM",
    code: "inevm",
    baseCurrencyName: "INJ",
    rpc: "https://inevm.calderachain.xyz/http/",
    explorer: "https://explorer.injective.network/"
  },
  "59144": {
    chainId: "59144",
    label: "Linea",
    shortName: "Linea",
    code: "linea",
    baseCurrencyName: "ETH",
    rpc: "https://rpc.linea.build/",
    explorer: "https://lineascan.build/"
  }
};

// src/config/envs.json
var envs_default = {
  production: {
    marginMode: "isolated",
    referralAPI: "https://electra.finance/referral-api",
    networks: {
      "1": {
        api: "https://electra.finance/eth-mainnet",
        services: {
          aggregator: {
            http: "/backend",
            ws: "/v1"
          },
          blockchain: {
            http: ""
          },
          priceFeed: {
            all: "/price-feed"
          }
        }
      },
      "56": {
        api: "https://electra.finance/bsc-mainnet",
        services: {
          aggregator: {
            http: "/backend",
            ws: "/v1"
          },
          blockchain: {
            http: ""
          },
          priceFeed: {
            all: "/price-feed"
          }
        }
      },
      "250": {
        api: "https://electra.finance/ftm-mainnet",
        services: {
          aggregator: {
            http: "/backend",
            ws: "/v1"
          },
          blockchain: {
            http: ""
          },
          priceFeed: {
            all: "/price-feed"
          }
        }
      },
      "137": {
        api: "https://electra.finance/polygon-mainnet",
        services: {
          aggregator: {
            http: "/backend",
            ws: "/v1"
          },
          blockchain: {
            http: ""
          },
          priceFeed: {
            all: "/price-feed"
          }
        }
      },
      "66": {
        api: "https://electra.finance/okc-mainnet",
        services: {
          aggregator: {
            http: "/backend",
            ws: "/v1"
          },
          blockchain: {
            http: ""
          },
          priceFeed: {
            all: "/price-feed"
          }
        }
      }
    },
    "2525": {
      api: "https://electra.finance/inevm-mainnet",
      services: {
        aggregator: {
          http: "/backend",
          ws: "/v1"
        },
        blockchain: {
          http: ""
        },
        priceFeed: {
          all: "/price-feed"
        }
      }
    },
    "59144": {
      api: "https://electra.finance/linea-mainnet",
      services: {
        aggregator: {
          http: "/backend",
          ws: "/v1"
        },
        blockchain: {
          http: ""
        },
        priceFeed: {
          all: "/price-feed"
        }
      }
    }
  },
  testing: {
    marginMode: "isolated",
    referralAPI: "https://testing.electra.finance/referral-api",
    networks: {
      "97": {
        api: "https://testing.electra.finance/bsc-testnet",
        services: {
          aggregator: {
            http: "/backend",
            ws: "/v1"
          },
          blockchain: {
            http: ""
          },
          priceFeed: {
            all: "/price-feed"
          }
        }
      },
      "5": {
        api: "https://testing.electra.finance/eth-goerli",
        services: {
          aggregator: {
            http: "/backend",
            ws: "/v1"
          },
          blockchain: {
            http: ""
          },
          priceFeed: {
            all: "/price-feed"
          }
        }
      },
      "421613": {
        api: "https://testing.electra.finance/arbitrum-goerli",
        services: {
          aggregator: {
            http: "/backend",
            ws: "/v1"
          },
          blockchain: {
            http: ""
          },
          priceFeed: {
            all: "/price-feed"
          }
        }
      },
      "4002": {
        api: "https://testing.electra.finance/ftm-testnet",
        services: {
          aggregator: {
            http: "/backend",
            ws: "/v1"
          },
          blockchain: {
            http: ""
          },
          priceFeed: {
            all: "/price-feed"
          }
        }
      },
      "80001": {
        api: "https://testing.electra.finance/polygon-mumbai",
        services: {
          aggregator: {
            http: "/backend",
            ws: "/v1"
          },
          blockchain: {
            http: ""
          },
          priceFeed: {
            all: "/price-feed"
          }
        }
      },
      "56303": {
        api: "https://testing.electra.finance/drip-testnet",
        services: {
          aggregator: {
            http: "/backend",
            ws: "/v1"
          },
          blockchain: {
            http: ""
          },
          priceFeed: {
            all: "/price-feed"
          }
        }
      }
    }
  },
  staging: {
    marginMode: "isolated",
    referralAPI: "https://staging.electra.finance/referral-api",
    networks: {
      "1": {
        api: "https://staging.electra.finance/eth-mainnet",
        services: {
          aggregator: {
            http: "/backend",
            ws: "/v1"
          },
          blockchain: {
            http: ""
          },
          priceFeed: {
            all: "/price-feed"
          }
        }
      },
      "56": {
        api: "https://staging.electra.finance/bsc-mainnet",
        services: {
          aggregator: {
            http: "/backend",
            ws: "/v1"
          },
          blockchain: {
            http: ""
          },
          priceFeed: {
            all: "/price-feed"
          }
        }
      },
      "250": {
        api: "https://staging.electra.finance/ftm-mainnet",
        services: {
          aggregator: {
            http: "/backend",
            ws: "/v1"
          },
          blockchain: {
            http: ""
          },
          priceFeed: {
            all: "/price-feed"
          }
        }
      },
      "137": {
        api: "https://staging.electra.finance/polygon-mainnet",
        services: {
          aggregator: {
            http: "/backend",
            ws: "/v1"
          },
          blockchain: {
            http: ""
          },
          priceFeed: {
            all: "/price-feed"
          }
        }
      },
      "66": {
        api: "https://staging.electra.finance/okc-mainnet",
        services: {
          aggregator: {
            http: "/backend",
            ws: "/v1"
          },
          blockchain: {
            http: ""
          },
          priceFeed: {
            all: "/price-feed"
          }
        }
      }
    },
    "2525": {
      api: "https://staging.electra.finance/inevm-mainnet",
      services: {
        aggregator: {
          http: "/backend",
          ws: "/v1"
        },
        blockchain: {
          http: ""
        },
        priceFeed: {
          all: "/price-feed"
        }
      }
    },
    "59144": {
      api: "https://staging.electra.finance/linea-mainnet",
      services: {
        aggregator: {
          http: "/backend",
          ws: "/v1"
        },
        blockchain: {
          http: ""
        },
        priceFeed: {
          all: "/price-feed"
        }
      }
    }
  },
  experimental: {
    marginMode: "isolated",
    referralAPI: "https://exp.electra.finance/referral-api",
    networks: {
      "97": {
        api: "https://exp.electra.finance/bsc-testnet",
        services: {
          aggregator: {
            http: "/backend",
            ws: "/v1"
          },
          blockchain: {
            http: ""
          },
          priceFeed: {
            all: "/price-feed"
          }
        }
      },
      "3": {
        api: "https://exp.electra.finance/eth-ropsten",
        services: {
          aggregator: {
            http: "/backend",
            ws: "/v1"
          },
          blockchain: {
            http: ""
          },
          priceFeed: {
            all: "/price-feed"
          }
        }
      }
    }
  }
};

// src/config/schemas/index.ts
var schemas_exports = {};
__export(schemas_exports, {
  eip712DomainSchema: () => eip712DomainSchema_default,
  knownEnvs: () => knownEnvs,
  pureChainInfoPayloadSchema: () => pureChainInfoPayloadSchema,
  pureChainInfoSchema: () => pureChainInfoSchema,
  pureEnvNetworksSchema: () => pureEnvNetworksSchema,
  pureEnvPayloadSchema: () => pureEnvPayloadSchema,
  pureEnvSchema: () => pureEnvSchema
});

// src/config/schemas/eip712DomainSchema.ts
import { z } from "zod";
var eip712DomainSchema = z.object({
  name: z.string(),
  version: z.string(),
  chainId: z.string(),
  verifyingContract: z.string(),
  salt: z.string()
}).partial().refine(
  (data) => Object.keys(data).length > 0,
  "At least one property should be filled in."
);
var eip712DomainSchema_default = eip712DomainSchema;

// src/config/schemas/pureEnvSchema.ts
import { z as z2 } from "zod";

// src/types.ts
var SupportedChainId = /* @__PURE__ */ ((SupportedChainId2) => {
  SupportedChainId2["MAINNET"] = "1";
  SupportedChainId2["ROPSTEN"] = "3";
  SupportedChainId2["GOERLI"] = "5";
  SupportedChainId2["ARBITRUM_GOERLI"] = "421613";
  SupportedChainId2["FANTOM_OPERA"] = "250";
  SupportedChainId2["POLYGON"] = "137";
  SupportedChainId2["OKC"] = "66";
  SupportedChainId2["INEVM"] = "2525";
  SupportedChainId2["LINEA"] = "59144";
  SupportedChainId2["POLYGON_TESTNET"] = "80001";
  SupportedChainId2["FANTOM_TESTNET"] = "4002";
  SupportedChainId2["BSC"] = "56";
  SupportedChainId2["BSC_TESTNET"] = "97";
  SupportedChainId2["OKC_TESTNET"] = "65";
  SupportedChainId2["DRIP_TESTNET"] = "56303";
  return SupportedChainId2;
})(SupportedChainId || {});
var HistoryTransactionStatus = /* @__PURE__ */ ((HistoryTransactionStatus2) => {
  HistoryTransactionStatus2["PENDING"] = "Pending";
  HistoryTransactionStatus2["DONE"] = "Done";
  HistoryTransactionStatus2["APPROVING"] = "Approving";
  HistoryTransactionStatus2["CANCELLED"] = "Cancelled";
  return HistoryTransactionStatus2;
})(HistoryTransactionStatus || {});

// src/config/schemas/pureEnvSchema.ts
var pureEnvNetworksSchema = z2.object({
  api: z2.string(),
  services: z2.object({
    blockchain: z2.object({
      http: z2.string()
    }),
    aggregator: z2.object({
      http: z2.string(),
      ws: z2.string()
    }),
    priceFeed: z2.object({
      all: z2.string()
    })
  }),
  rpc: z2.string().optional()
});
var pureEnvPayloadSchema = z2.object({
  marginMode: z2.enum(["isolated", "cross"]),
  referralAPI: z2.string().url(),
  networks: z2.record(
    z2.nativeEnum(SupportedChainId),
    pureEnvNetworksSchema
  )
});
var knownEnvs = ["production", "staging", "testing"];
var pureEnvSchema = z2.record(
  z2.enum(knownEnvs).or(z2.string()),
  pureEnvPayloadSchema
);

// src/config/schemas/pureChainSchema.ts
import { z as z3 } from "zod";

// src/constants/cancelOrderTypes.ts
var CANCEL_ORDER_TYPES = {
  DeleteOrder: [
    { name: "senderAddress", type: "address" },
    { name: "id", type: "string" }
  ]
};
var cancelOrderTypes_default = CANCEL_ORDER_TYPES;

// src/constants/subOrderStatuses.ts
var subOrderStatuses = [
  "NEW",
  // created, wasn't added to IOB or wasn't accepted by the broker
  "ACCEPTED",
  // added to IOB or accepted by the broker
  "PARTIALLY_FILLED",
  // partially filled
  "FILLED",
  // fully filled
  "TX_PENDING",
  // sub order was filled and at least one of its trades is pending
  "CANCELED",
  // canceled by user or by expiration
  "REJECTED",
  // rejected by broker
  "FAILED",
  // at least one trade failed
  "SETTLED",
  // all trades successfully settled
  "NOT_FOUND"
  // broker not processed sub order yet
];
var subOrderStatuses_default = subOrderStatuses;

// src/constants/orderStatuses.ts
var orderStatuses = [
  ...subOrderStatuses_default,
  "ROUTING"
  // order got sub orders, but not all of them have status ACCEPTED
];
var orderStatuses_default = orderStatuses;

// src/constants/networkCodes.ts
var networkCodes_default = ["ftm", "bsc", "eth", "polygon", "okc", "arb", "drip", "inevm", "linea"];

// src/constants/orderSides.ts
var orderSides = [
  "SELL",
  "BUY"
];

// src/constants/chains.ts
var developmentChains = [
  "97" /* BSC_TESTNET */,
  "3" /* ROPSTEN */,
  "5" /* GOERLI */,
  "421613" /* ARBITRUM_GOERLI */,
  "4002" /* FANTOM_TESTNET */,
  "80001" /* POLYGON_TESTNET */,
  "65" /* OKC_TESTNET */
];
var productionChains = [
  "1" /* MAINNET */,
  "56" /* BSC */,
  "250" /* FANTOM_OPERA */,
  "137" /* POLYGON */,
  "66" /* OKC */,
  "2525" /* INEVM */,
  "59144" /* LINEA */
];

// src/constants/precisions.ts
var INTERNAL_PROTOCOL_PRECISION = 8;
var NATIVE_CURRENCY_PRECISION = 18;

// src/constants/gasLimits.ts
var DEPOSIT_ETH_GAS_LIMIT = 7e4;
var DEPOSIT_ERC20_GAS_LIMIT = 15e4;
var WITHDRAW_GAS_LIMIT = DEPOSIT_ERC20_GAS_LIMIT;
var APPROVE_ERC20_GAS_LIMIT = 8e4;
var FILL_ORDERS_GAS_LIMIT = 22e4;
var DEFAULT_GAS_LIMIT = 7e5;
var GOVERNANCE_GET_REWARD_GAS_LIMIT = 25e4;
var GOVERNANCE_STAKE_GAS_LIMIT = 3e5;
var GOVERNANCE_UNSTAKE_GAS_LIMIT = 25e4;
var GOVERNANCE_VOTE_GAS_LIMIT = 2e5;
var VOTE_ERC20_GAS_LIMIT = 15e4;

// src/constants/index.ts
var DEFAULT_EXPIRATION = 29 * 24 * 60 * 60 * 1e3;

// src/config/schemas/pureChainSchema.ts
var pureChainInfoPayloadSchema = z3.object({
  chainId: z3.nativeEnum(SupportedChainId),
  label: z3.string(),
  shortName: z3.string(),
  code: z3.enum(networkCodes_default),
  explorer: z3.string(),
  rpc: z3.string(),
  baseCurrencyName: z3.string()
});
var pureChainInfoSchema = z3.record(
  z3.nativeEnum(SupportedChainId),
  pureChainInfoPayloadSchema
);

// src/config/index.ts
var chains = pureChainInfoSchema.parse(chains_default);
var envs = pureEnvSchema.parse(envs_default);

// src/Unit/index.ts
import { ethers as ethers8 } from "ethers";

// src/services/Aggregator/index.ts
var Aggregator_exports = {};
__export(Aggregator_exports, {
  Aggregator: () => Aggregator,
  schemas: () => schemas_exports3,
  ws: () => ws_exports
});
import { z as z30 } from "zod";

// src/services/Aggregator/schemas/exchangeInfoSchema.ts
import { z as z5 } from "zod";

// src/services/Aggregator/schemas/pairConfigSchema.ts
import { z as z4 } from "zod";
var pairConfigSchema = z4.object({
  maxPrice: z4.number(),
  maxQty: z4.number(),
  minPrice: z4.number(),
  minQty: z4.number(),
  name: z4.string().toUpperCase(),
  pricePrecision: z4.number().int(),
  qtyPrecision: z4.number().int()
});
var pairConfigSchema_default = pairConfigSchema;

// src/services/Aggregator/schemas/exchangeInfoSchema.ts
var exchangeInfoSchema = z5.array(pairConfigSchema_default);
var exchangeInfoSchema_default = exchangeInfoSchema;

// src/services/Aggregator/schemas/cancelOrderSchema.ts
import { z as z6 } from "zod";
var cancelOrderSchema = z6.object({
  orderId: z6.union([z6.number(), z6.string()]),
  cancellationRequests: z6.array(z6.object({
    amount: z6.number(),
    brokerAddress: z6.string(),
    exchange: z6.string()
  })).optional(),
  remainingAmount: z6.number().optional()
});
var cancelOrderSchema_default = cancelOrderSchema;

// src/services/Aggregator/schemas/errorSchema.ts
import { z as z7 } from "zod";
var errorSchema = z7.object({
  error: z7.object({
    code: z7.number(),
    reason: z7.string()
  }),
  timestamp: z7.string()
});
var errorSchema_default = errorSchema;

// src/services/Aggregator/ws/index.ts
var ws_exports = {};
__export(ws_exports, {
  AggregatorWS: () => AggregatorWS,
  MessageType: () => MessageType_default,
  SubscriptionType: () => SubscriptionType_default,
  UnsubscriptionType: () => UnsubscriptionType_default,
  schemas: () => schemas_exports2
});
import { z as z27 } from "zod";
import { validate as uuidValidate, v4 as uuidv4 } from "uuid";

// src/services/Aggregator/ws/MessageType.ts
var MessageType = {
  ERROR: "e",
  PING_PONG: "pp",
  INITIALIZATION: "i",
  AGGREGATED_ORDER_BOOK_UPDATE: "aobu",
  ASSET_PAIRS_CONFIG_UPDATE: "apcu",
  ASSET_PAIR_CONFIG_UPDATE: "apiu",
  ADDRESS_UPDATE: "au",
  ISOLATED_ADDRESS_UPDATE: "iau",
  CFD_ADDRESS_UPDATE: "auf",
  ISOLATED_CFD_ADDRESS_UPDATE: "iauf",
  FUTURES_TRADE_INFO_UPDATE: "fti",
  FUTURES_TRADES_STREAM_UPDATE: "ftsu",
  UNSUBSCRIPTION_DONE: "ud"
};
var MessageType_default = MessageType;

// src/services/Aggregator/ws/SubscriptionType.ts
var SubscriptionType = {
  ASSET_PAIRS_CONFIG_UPDATES_SUBSCRIBE: "apcus",
  ASSET_PAIR_CONFIG_UPDATES_SUBSCRIBE: "apius",
  ADDRESS_UPDATES_SUBSCRIBE: "aus",
  ISOLATED_ADDRESS_UPDATES_SUBSCRIBE: "iaus",
  AGGREGATED_ORDER_BOOK_UPDATES_SUBSCRIBE: "aobus",
  CFD_ADDRESS_UPDATES_SUBSCRIBE: "ausf",
  ISOLATED_CFD_ADDRESS_UPDATES_SUBSCRIBE: "iausf",
  FUTURES_TRADE_INFO_SUBSCRIBE: "fts",
  FUTURES_TRADES_STREAM_SUBSCRIBE: "ftss"
};
var SubscriptionType_default = SubscriptionType;

// src/services/Aggregator/ws/schemas/index.ts
var schemas_exports2 = {};
__export(schemas_exports2, {
  addressUpdateSchema: () => addressUpdateSchema_default,
  assetPairsConfigSchema: () => assetPairsConfigSchema_default,
  balancesSchema: () => balancesSchema_default,
  baseMessageSchema: () => baseMessageSchema_default,
  cfdBalancesSchema: () => cfdBalancesSchema_default,
  errorSchema: () => errorSchema_default2,
  futuresTradesStreamSchema: () => futuresTradesStreamSchema,
  initMessageSchema: () => initMessageSchema_default,
  isolatedAddressUpdateSchema: () => isolatedAddressUpdateSchema_default,
  isolatedCFDBalancesSchema: () => isolatedCFDBalancesSchema_default,
  orderBookItemSchema: () => orderBookItemSchema,
  orderBookSchema: () => orderBookSchema,
  pingPongMessageSchema: () => pingPongMessageSchema_default
});

// src/services/Aggregator/ws/schemas/addressUpdateSchema.ts
import { z as z11 } from "zod";

// src/services/Aggregator/ws/schemas/balancesSchema.ts
import { z as z9 } from "zod";

// src/utils/index.ts
var utils_exports = {};
__export(utils_exports, {
  calculateNetworkFee: () => calculateNetworkFee,
  checkIsToken: () => checkIsToken_default,
  denormalizeNumber: () => denormalizeNumber,
  generateSecret: () => generateSecret_default,
  getNativeCryptocurrencyName: () => getNativeCryptocurrencyName_default,
  hasProp: () => hasProp,
  isKeyOfObject: () => isKeyOfObject,
  isKnownEnv: () => isKnownEnv_default,
  isNetworkCodeInEnvironment: () => isNetworkCodeInEnvironment,
  isUnknownObject: () => isUnknownObject,
  isUppercasedNetworkCode: () => isUppercasedNetworkCode_default,
  isValidChainId: () => isValidChainId_default,
  isWithCode: () => isWithCode,
  isWithData: () => isWithData,
  isWithError: () => isWithError,
  isWithMessage: () => isWithMessage,
  isWithReason: () => isWithReason,
  makePartial: () => makePartial,
  normalizeNumber: () => normalizeNumber,
  toLowerCase: () => toLowerCase,
  toUpperCase: () => toUpperCase
});

// src/utils/calculateNetworkFee.ts
import { BigNumber } from "bignumber.js";
import { ethers } from "ethers";
function calculateNetworkFee(gasPriceGwei, gasLimit) {
  const networkFeeGwei = new BigNumber(gasPriceGwei).multipliedBy(gasLimit);
  const bn = new BigNumber(ethers.parseUnits(networkFeeGwei.toString(), "gwei").toString());
  return bn.div(new BigNumber(10).pow(NATIVE_CURRENCY_PRECISION)).toString();
}

// src/utils/checkIsToken.ts
import { ERC20__factory } from "@electra.finance/contracts/lib/ethers-v6/index.js";
import { ethers as ethers2 } from "ethers";
import invariant from "tiny-invariant";
var checkIsToken = async (address, provider) => {
  invariant(provider, "No provider for token checking");
  const tokenContract = ERC20__factory.connect(address, provider);
  try {
    const results = await Promise.all(
      [
        tokenContract.name(),
        tokenContract.symbol(),
        tokenContract.decimals(),
        tokenContract.totalSupply(),
        tokenContract.balanceOf(ethers2.ZeroAddress)
      ]
    );
    return Boolean(results);
  } catch (err) {
    return false;
  }
};
var checkIsToken_default = checkIsToken;

// src/utils/generateSecret.ts
import { ethers as ethers3 } from "ethers";
var XorShift128Plus = class {
  x;
  y;
  constructor(seed) {
    this.x = seed;
    this.y = seed ^ 1831565813;
  }
  nextInt32() {
    let x = this.x;
    const y = this.y;
    this.x = y;
    x ^= x << 23;
    x ^= x >> 17;
    x ^= y ^ y >> 26;
    this.y = x;
    return x + y;
  }
};
function generateSeed() {
  return Math.floor(Date.now() * Math.random());
}
function generateRandomBytes(size, rng) {
  const buffer = new Uint8Array(size);
  for (let i = 0; i < size; i++) {
    buffer[i] = rng.nextInt32() & 255;
  }
  return buffer;
}
function isomorphicCryptoRandomBytes(size) {
  const seed = generateSeed();
  const rng = new XorShift128Plus(seed);
  return generateRandomBytes(size, rng);
}
var generateSecret = () => {
  const RANDOM_BITS = 256;
  const rand = isomorphicCryptoRandomBytes(RANDOM_BITS);
  const secret = ethers3.keccak256(rand);
  return secret;
};
var generateSecret_default = generateSecret;

// src/utils/denormalizeNumber.ts
import { BigNumber as BigNumber2 } from "bignumber.js";
function denormalizeNumber(input, decimals) {
  const decimalsBN = new BigNumber2(decimals.toString());
  if (!decimalsBN.isInteger())
    throw new Error(`Decimals '${decimalsBN.toString()}' is not an integer`);
  return new BigNumber2(input.toString()).div(new BigNumber2(10).pow(decimalsBN));
}

// src/utils/normalizeNumber.ts
import { BigNumber as BigNumber3 } from "bignumber.js";
function normalizeNumber(input, decimals, roundingMode) {
  const decimalsBN = new BigNumber3(decimals);
  if (!decimalsBN.isInteger())
    throw new Error(`Decimals '${decimalsBN.toString()}' is not an integer`);
  const inputBN = new BigNumber3(input);
  return BigInt(
    inputBN.multipliedBy(new BigNumber3(10).pow(decimals)).integerValue(roundingMode).toString()
  );
}

// src/utils/isNetworkCodeInEnvironment.ts
function isNetworkCodeInEnvironment(networkCode, env) {
  if (!(env in envs)) {
    throw new Error(`Env ${env} is not supported. Available environments is: ${Object.keys(envs).join(", ")}`);
  }
  const envInfo = envs[env];
  const envNetworks = envInfo?.networks;
  if (!envNetworks)
    throw new Error("Env networks is undefined (isNetworkCodeInEnvironment)");
  return Object.values(chains).some((chain) => chain.code.toLowerCase() === networkCode.toLowerCase() && chain.chainId in envNetworks);
}

// src/utils/toUpperCase.ts
function toUpperCase(str) {
  return str.toUpperCase();
}

// src/utils/toLowerCase.ts
function toLowerCase(str) {
  return str.toLowerCase();
}

// src/utils/isUppercasedNetworkCode.ts
var isUppercasedNetworkCode = (value) => networkCodes_default.map(toUpperCase).some((networkCode) => networkCode === value);
var isUppercasedNetworkCode_default = isUppercasedNetworkCode;

// src/utils/getNativeCryptocurrencyName.ts
import { ethers as ethers4 } from "ethers";
var getNativeCryptocurrencyName = (assetToAddress) => {
  const addressToAssetName = Object.entries(assetToAddress).reduce((prev, [assetName, address]) => {
    if (address === void 0)
      return prev;
    return {
      ...prev,
      [address]: assetName
    };
  }, {});
  const nativeCryptocurrencyName = addressToAssetName[ethers4.ZeroAddress];
  if (nativeCryptocurrencyName === void 0) {
    throw new Error("Native cryptocurrency asset name is not found");
  }
  return nativeCryptocurrencyName;
};
var getNativeCryptocurrencyName_default = getNativeCryptocurrencyName;

// src/utils/isValidChainId.ts
import { z as z8 } from "zod";
var isValidChainId = (chainId) => {
  const { success } = z8.nativeEnum(SupportedChainId).safeParse(chainId);
  return success;
};
var isValidChainId_default = isValidChainId;

// src/utils/isKnownEnv.ts
var isKnownEnv = (env) => {
  return knownEnvs.some((knownEnv) => knownEnv === env);
};
var isKnownEnv_default = isKnownEnv;

// src/utils/typeHelpers.ts
var makePartial = (value) => value;
function isUnknownObject(x) {
  return x !== null && typeof x === "object";
}
function isKeyOfObject(key, obj) {
  return key in obj;
}
function hasProp(obj, key) {
  return key in obj;
}
function isWithCode(candidate) {
  if (!isUnknownObject(candidate) || !hasProp(candidate, "code"))
    return false;
  const type = typeof candidate.code;
  return type === "number" || type === "string";
}
function isWithReason(candidate) {
  if (!isUnknownObject(candidate))
    return false;
  const hasReasonProperty = hasProp(candidate, "reason") && typeof candidate.reason === "string";
  return hasReasonProperty;
}
function isWithMessage(candidate) {
  if (!isUnknownObject(candidate))
    return false;
  const hasMessageProperty = hasProp(candidate, "message") && typeof candidate.message === "string";
  return hasMessageProperty;
}
function isWithError(candidate) {
  if (!isUnknownObject(candidate))
    return false;
  const hasErrorProperty = hasProp(candidate, "error") && isUnknownObject(candidate.error);
  return hasErrorProperty;
}
function isWithData(candidate) {
  if (!isUnknownObject(candidate))
    return false;
  const hasDataProperty = hasProp(candidate, "data") && typeof candidate.data === "object";
  return hasDataProperty;
}

// src/services/Aggregator/ws/schemas/balancesSchema.ts
var balancesSchema = z9.record(
  // changed balances in format
  z9.string().toUpperCase(),
  // asset
  z9.tuple([
    z9.string(),
    // tradable balance
    z9.string(),
    // reserved balance
    z9.string(),
    // contract balance
    z9.string(),
    // wallet balance
    z9.string()
    // allowance
  ])
).transform(makePartial);
var balancesSchema_default = balancesSchema;

// src/services/Aggregator/ws/schemas/baseMessageSchema.ts
import { z as z10 } from "zod";
var baseMessageSchema = z10.object({
  T: z10.nativeEnum(MessageType_default),
  _: z10.number()
});
var baseMessageSchema_default = baseMessageSchema;

// src/constants/cfdExecutionTypes.ts
var executionTypes = ["LIMIT", "STOP_LIMIT"];
var cfdExecutionTypes_default = executionTypes;

// src/services/Aggregator/ws/schemas/addressUpdateSchema.ts
var baseAddressUpdate = baseMessageSchema_default.extend({
  id: z11.string(),
  T: z11.literal(MessageType_default.ADDRESS_UPDATE),
  S: z11.string(),
  // subscription
  uc: z11.array(z11.enum(["b", "o"]))
  // update content
});
var subOrderSchema = z11.object({
  i: z11.number(),
  // id
  I: z11.string(),
  // parent order id
  O: z11.string(),
  // sender (owner)
  P: z11.string().toUpperCase(),
  // instrument
  s: z11.enum(["BUY", "SELL"]),
  // side
  a: z11.number(),
  // amount
  A: z11.number(),
  // settled amount
  p: z11.number(),
  // price
  b: z11.string(),
  // broker address
  S: z11.enum(subOrderStatuses_default),
  // status
  o: z11.boolean().optional()
  // internal only
});
var getTransformedSubOrders = (subOrders) => {
  return subOrders.map((so) => ({
    id: so.i,
    parentId: so.I,
    sender: so.O,
    instrument: so.P,
    side: so.s,
    amount: so.a,
    settledAmount: so.A,
    price: so.p,
    brokerAddress: so.b,
    status: so.S
  }));
};
var orderUpdateSchema = z11.object({
  I: z11.string(),
  // id
  A: z11.number(),
  // settled amount
  S: z11.enum(orderStatuses_default),
  // status
  l: z11.boolean().optional(),
  // is liquidation order
  t: z11.number(),
  // update time
  E: z11.enum(cfdExecutionTypes_default).optional(),
  // execution type
  C: z11.string().optional(),
  // trigger condition
  lv: z11.number().optional(),
  // leverage
  roi: z11.number().optional(),
  // ROI%
  rpnl: z11.number().optional(),
  // realized PnL
  sltp: z11.enum(["STOP_LOSS", "TAKE_PROFIT"]).optional(),
  // side
  c: subOrderSchema.array()
  // sub orders (content)
}).transform((val) => ({
  ...val,
  k: "update"
})).transform((o) => ({
  kind: o.k,
  id: o.I,
  settledAmount: o.A,
  status: o.S,
  liquidated: o.l,
  executionType: o.E,
  triggerCondition: o.C,
  leverage: o.lv,
  roi: o.roi,
  realizedPnL: o.rpnl,
  sltp: o.sltp,
  subOrders: getTransformedSubOrders(o.c)
}));
var fullOrderSchema = z11.object({
  I: z11.string(),
  // id
  O: z11.string(),
  // sender (owner)
  P: z11.string().toUpperCase(),
  // asset pair
  s: z11.enum(["BUY", "SELL"]),
  // side
  sltp: z11.enum(["STOP_LOSS", "TAKE_PROFIT"]).optional(),
  // side
  a: z11.number(),
  // amount
  A: z11.number(),
  // settled amount
  p: z11.number(),
  // signed price
  E: z11.enum(cfdExecutionTypes_default).optional(),
  // execution type
  C: z11.string().optional(),
  // trigger condition
  F: z11.string().toUpperCase(),
  // fee asset
  f: z11.number().optional(),
  // fee
  o: z11.boolean(),
  // internal only
  S: z11.enum(orderStatuses_default),
  // status
  ro: z11.boolean().optional(),
  // reversed order
  T: z11.number(),
  // creation time / unix timestamp
  t: z11.number(),
  // update time
  lv: z11.number().optional(),
  // leverage
  roi: z11.number().optional(),
  // ROI%
  ep: z11.number().optional(),
  // entry price
  c: subOrderSchema.array(),
  // sub orders (content)
  // CFD only
  L: z11.number().optional(),
  // stop limit price,
  l: z11.boolean().optional(),
  // is liquidation order
  rpnl: z11.number().optional()
  // realized PnL
}).transform((val) => ({
  ...val,
  k: "full"
})).transform((o) => ({
  kind: o.k,
  id: o.I,
  clientOrdId: o.O,
  instrument: o.P,
  side: o.s,
  sltp: o.sltp,
  amount: o.a,
  settledAmount: o.A,
  price: o.p,
  executionType: o.E,
  triggerCondition: o.C,
  feeAsset: o.F,
  fee: o.f,
  internalOnly: o.o,
  status: o.S,
  date: o.T,
  updateDate: o.t,
  stopPrice: o.L,
  liquidated: o.l,
  realizedPnL: o.rpnl,
  leverage: o.lv,
  roi: o.roi,
  entryPrice: o.ep,
  subOrders: getTransformedSubOrders(o.c)
}));
var updateMessageSchema = baseAddressUpdate.extend({
  k: z11.literal("u"),
  // kind of message: "u" - updates
  uc: z11.array(z11.enum(["b", "o"])),
  // update content: "o" - orders updates, "b" - balance updates
  b: balancesSchema_default.optional(),
  o: z11.tuple([fullOrderSchema.or(orderUpdateSchema)]).optional()
});
var initialMessageSchema = baseAddressUpdate.extend({
  k: z11.literal("i"),
  // kind of message: "i" - initial
  b: balancesSchema_default,
  o: z11.array(fullOrderSchema).optional()
  // When no orders — no field
});
var addressUpdateSchema = z11.union([
  initialMessageSchema,
  updateMessageSchema
]);
var addressUpdateSchema_default = addressUpdateSchema;

// src/services/Aggregator/ws/schemas/isolatedAddressUpdateSchema.ts
import { z as z12 } from "zod";
var baseAddressUpdate2 = baseMessageSchema_default.extend({
  id: z12.string(),
  T: z12.literal(MessageType_default.ISOLATED_ADDRESS_UPDATE),
  S: z12.string(),
  // subscription
  uc: z12.array(z12.enum(["b", "o"]))
  // update content
});
var isolatedSubOrderSchema = z12.object({
  i: z12.number(),
  // id
  I: z12.string(),
  // parent order id
  O: z12.string(),
  // sender (owner)
  P: z12.string().toUpperCase(),
  // asset pair
  s: z12.enum(["BUY", "SELL"]),
  // side
  a: z12.number(),
  // amount
  A: z12.number(),
  // settled amount
  p: z12.number(),
  // avg weighed settlement price
  b: z12.string(),
  // broker address
  S: z12.enum(subOrderStatuses_default),
  // status
  o: z12.boolean()
  // internal only
});
var getTransformedIsolatedSubOrders = (subOrders) => {
  return subOrders.map((so) => ({
    pair: so.P,
    id: so.i,
    amount: so.a,
    settledAmount: so.A,
    price: so.p,
    status: so.S,
    side: so.s,
    subOrdQty: so.A
  }));
};
var isolatedOrderUpdateSchema = z12.object({
  I: z12.string(),
  // id
  A: z12.number(),
  // settled amount
  S: z12.enum(orderStatuses_default),
  // status
  l: z12.boolean().optional(),
  // is liquidation order
  t: z12.number(),
  // update time
  E: z12.enum(cfdExecutionTypes_default).optional(),
  // execution type
  C: z12.string().optional(),
  // trigger condition
  rpnl: z12.number().optional(),
  // realized PnL
  c: isolatedSubOrderSchema.array()
  // sub orders (content)
}).transform((val) => ({
  ...val,
  k: "update"
})).transform((o) => ({
  kind: o.k,
  id: o.I,
  settledAmount: o.A,
  status: o.S,
  liquidated: o.l,
  executionType: o.E,
  triggerCondition: o.C,
  realizedPnL: o.rpnl,
  subOrders: getTransformedIsolatedSubOrders(o.c)
}));
var isolatedFullOrderSchema = z12.object({
  I: z12.string(),
  // id
  O: z12.string(),
  // sender (owner)
  P: z12.string().toUpperCase(),
  // asset pair
  s: z12.enum(["BUY", "SELL"]),
  // side
  a: z12.number(),
  // amount
  A: z12.number(),
  // settled amount
  p: z12.number(),
  // signed price
  E: z12.enum(cfdExecutionTypes_default).optional(),
  // execution type
  C: z12.string().optional(),
  // trigger condition
  F: z12.string().toUpperCase(),
  // fee asset
  f: z12.number(),
  // fee
  o: z12.boolean(),
  // internal only
  S: z12.enum(orderStatuses_default),
  // status
  T: z12.number(),
  // creation time / unix timestamp
  t: z12.number(),
  // update time
  c: isolatedSubOrderSchema.array(),
  // sub orders (content)
  // CFD only
  L: z12.number().optional(),
  // stop limit price,
  l: z12.boolean().optional(),
  // is liquidation order
  rpnl: z12.number().optional()
  // realized PnL
}).transform((val) => ({
  ...val,
  k: "full"
})).transform((o) => ({
  kind: o.k,
  id: o.I,
  clientOrdId: o.O,
  instrument: o.P,
  side: o.s,
  amount: o.a,
  settledAmount: o.A,
  price: o.p,
  executionType: o.E,
  triggerCondition: o.C,
  feeAsset: o.F,
  fee: o.f,
  status: o.S,
  date: o.T,
  stopPrice: o.L,
  liquidated: o.l,
  realizedPnL: o.rpnl,
  subOrders: getTransformedIsolatedSubOrders(o.c)
}));
var updateMessageSchema2 = baseAddressUpdate2.extend({
  k: z12.literal("u"),
  // kind of message: "u" - updates
  uc: z12.array(z12.enum(["b", "o"])),
  // update content: "o" - orders updates, "b" - balance updates
  b: balancesSchema_default.optional(),
  o: z12.tuple([isolatedFullOrderSchema.or(isolatedOrderUpdateSchema)]).optional()
});
var initialMessageSchema2 = baseAddressUpdate2.extend({
  k: z12.literal("i"),
  // kind of message: "i" - initial
  b: balancesSchema_default,
  o: z12.array(isolatedFullOrderSchema).optional()
  // When no orders — no field
});
var isolatedAddressUpdateSchema = z12.union([
  initialMessageSchema2,
  updateMessageSchema2
]);
var isolatedAddressUpdateSchema_default = isolatedAddressUpdateSchema;

// src/services/Aggregator/ws/schemas/assetPairsConfigSchema.ts
import { z as z13 } from "zod";
var assetPairsConfigSchema = baseMessageSchema_default.extend({
  id: z13.string(),
  T: z13.literal(MessageType_default.ASSET_PAIRS_CONFIG_UPDATE),
  k: z13.enum(["i", "u"]),
  u: z13.array(
    z13.tuple([
      z13.string().toUpperCase(),
      // pairName
      z13.number(),
      // minQty
      z13.number().int()
      // pricePrecision
    ])
  )
});
var assetPairsConfigSchema_default = assetPairsConfigSchema;

// src/services/Aggregator/ws/schemas/errorSchema.ts
import { z as z14 } from "zod";
var errorSchema2 = baseMessageSchema_default.extend({
  T: z14.literal(MessageType_default.ERROR),
  c: z14.number().int(),
  // code
  id: z14.string().optional(),
  // subscription id
  m: z14.string()
  // error message,
});
var errorSchema_default2 = errorSchema2;

// src/services/Aggregator/ws/schemas/initMessageSchema.ts
import { z as z15 } from "zod";
var initMessageSchema = baseMessageSchema_default.extend({
  T: z15.literal(MessageType_default.INITIALIZATION),
  i: z15.string()
});
var initMessageSchema_default = initMessageSchema;

// src/services/Aggregator/ws/schemas/pingPongMessageSchema.ts
import { z as z16 } from "zod";
var pingPongMessageSchema = baseMessageSchema_default.extend({
  T: z16.literal(MessageType_default.PING_PONG)
});
var pingPongMessageSchema_default = pingPongMessageSchema;

// src/services/Aggregator/ws/schemas/cfdBalancesSchema.ts
import { z as z17 } from "zod";

// src/constants/positionStatuses.ts
var positionSides = [
  "LONG",
  "SHORT"
];
var positionStatuses = [
  ...positionSides,
  "CLOSING",
  "LIQUIDATION",
  "ZERO"
];
var positionStatuses_default = positionStatuses;

// src/services/Aggregator/ws/schemas/cfdBalancesSchema.ts
var sbiSchema = z17.object({
  i: z17.string(),
  // instrument
  s: z17.enum(positionStatuses_default),
  // position status
  cp: z17.string(),
  // current price
  pnl: z17.string(),
  // floating profit & loss
  fr: z17.string(),
  // accumulated funding rate
  p: z17.string(),
  // position
  pp: z17.string(),
  // position price
  m: z17.string(),
  // margin
  mu: z17.string(),
  // margin in USD
  l: z17.string(),
  // leverage
  lfrs: z17.string(),
  // long funding rate per second
  lfrd: z17.string(),
  // long funding rate per day
  sfrs: z17.string(),
  // short funding rate per second
  sfrd: z17.string(),
  // short funding rate per day
  sop: z17.string().optional()
  // stop out price
});
var cfdBalanceSchema = z17.object({
  b: z17.string(),
  // balance
  pnl: z17.string(),
  // total floating profit & loss
  fr: z17.string(),
  // total accumulated funding rate
  e: z17.string(),
  // equity
  r: z17.string(),
  // total reserves
  m: z17.string().optional(),
  // margin
  mu: z17.string(),
  // total margin in USD
  fmu: z17.string(),
  // total free margin in USD
  awb: z17.string(),
  // available withdraw balance
  sbi: sbiSchema.array()
  // states by instruments
}).transform((obj) => {
  const sbi = obj.sbi.map((state) => {
    return {
      instrument: state.i,
      positionStatus: state.s,
      currentPrice: state.cp,
      floatingProfitLoss: state.pnl,
      accumulatedFundingRate: state.fr,
      position: state.p,
      positionPrice: state.pp,
      margin: state.m,
      marginUSD: state.mu,
      leverage: state.l,
      longFundingRatePerSecond: state.lfrs,
      longFundingRatePerDay: state.lfrd,
      shortFundingRatePerSecond: state.sfrs,
      shortFundingRatePerDay: state.sfrd,
      stopOutPrice: state.sop
    };
  });
  return {
    balance: obj.b,
    profitLoss: obj.pnl,
    fundingRate: obj.fr,
    equity: obj.e,
    reserves: obj.r,
    margin: obj.m,
    marginUSD: obj.mu,
    freeMarginUSD: obj.fmu,
    availableWithdrawBalance: obj.awb,
    statesByInstruments: sbi
  };
});
var cfdBalancesSchema = z17.array(cfdBalanceSchema);
var cfdBalancesSchema_default = cfdBalancesSchema;

// src/services/Aggregator/ws/schemas/isolatedCFDBalancesSchema.ts
import { z as z18 } from "zod";
var isolatedCFDBalanceSchema = z18.object({
  i: z18.string(),
  b: z18.string(),
  pnl: z18.string(),
  fr: z18.string(),
  e: z18.string(),
  p: z18.string(),
  cp: z18.string(),
  pp: z18.string(),
  r: z18.string(),
  m: z18.string(),
  mu: z18.string(),
  fmu: z18.string(),
  awb: z18.string(),
  l: z18.string(),
  s: z18.enum(positionStatuses_default),
  lfrs: z18.string(),
  lfrd: z18.string(),
  sfrs: z18.string(),
  sfrd: z18.string(),
  sop: z18.string().optional()
}).transform((obj) => ({
  instrument: obj.i,
  balance: obj.b,
  profitLoss: obj.pnl,
  fundingRate: obj.fr,
  equity: obj.e,
  position: obj.p,
  currentPrice: obj.cp,
  positionPrice: obj.pp,
  reserves: obj.r,
  margin: obj.m,
  marginUSD: obj.mu,
  freeMarginUSD: obj.fmu,
  availableWithdrawBalance: obj.awb,
  leverage: obj.l,
  status: obj.s,
  longFundingRatePerSecond: obj.lfrs,
  longFundingRatePerDay: obj.lfrd,
  shortFundingRatePerSecond: obj.sfrs,
  shortFundingRatePerDay: obj.sfrd,
  stopOutPrice: obj.sop
}));
var isolatedCFDBalancesSchema = z18.array(isolatedCFDBalanceSchema);
var isolatedCFDBalancesSchema_default = isolatedCFDBalancesSchema;

// src/services/Aggregator/ws/schemas/futuresTradesStreamSchema.ts
import { z as z20 } from "zod";

// src/addressSchema.ts
import { ethers as ethers5 } from "ethers";
import { z as z19 } from "zod";
var addressSchema = z19.string().refine(ethers5.isAddress, (value) => ({
  message: `Should be an address, got ${value}`
}));
var addressSchema_default = addressSchema;

// src/services/Aggregator/ws/schemas/futuresTradesStreamSchema.ts
var futuresTradesStreamSchema = z20.object({
  T: z20.literal(MessageType_default.FUTURES_TRADES_STREAM_UPDATE),
  // futures trades stream update
  _: z20.number(),
  // timestamp
  S: addressSchema_default,
  // sender
  id: z20.string(),
  // request id
  i: z20.string(),
  // instrument
  s: z20.enum(orderSides),
  // trade side (SELL/BUY)
  ps: z20.enum(positionSides),
  // trade side (SELL/BUY)
  a: z20.string(),
  // trade amount
  l: z20.string(),
  // leverage
  p: z20.string(),
  // price
  h: z20.string(),
  // transaction hash
  n: z20.enum(networkCodes_default),
  // network
  rpnl: z20.string().optional(),
  // realized PnL, optional
  r: z20.string().optional()
  // ROI in %, optional
});

// src/services/Aggregator/ws/schemas/orderBookSchema.ts
import { z as z21 } from "zod";
var orderBookItemSchema = z21.tuple([
  z21.string(),
  // price
  z21.string(),
  // size
  z21.array(z21.tuple([
    z21.enum(["SELL", "BUY"]),
    // side
    z21.string().toUpperCase()
    // pairname
  ]))
]);
var orderBookSchema = baseMessageSchema_default.extend({
  // id: z.string(),
  T: z21.literal(MessageType_default.AGGREGATED_ORDER_BOOK_UPDATE),
  S: z21.string(),
  ob: z21.object({
    a: z21.array(orderBookItemSchema),
    b: z21.array(orderBookItemSchema)
  })
});

// src/services/Aggregator/ws/UnsubscriptionType.ts
var UnsubscriptionType = {
  ASSET_PAIRS_CONFIG_UPDATES_UNSUBSCRIBE: "apcu",
  FUTURES_TRADES_STREAM_UNSUBSCRIBE: "ftsu"
};
var UnsubscriptionType_default = UnsubscriptionType;

// src/services/Aggregator/ws/schemas/unsubscriptionDoneSchema.ts
import { z as z22 } from "zod";
var unsubscriptionDoneSchema = baseMessageSchema_default.extend({
  id: z22.string(),
  T: z22.literal(MessageType_default.UNSUBSCRIPTION_DONE)
});
var unsubscriptionDoneSchema_default = unsubscriptionDoneSchema;

// src/services/Aggregator/ws/schemas/assetPairConfigSchema.ts
import { z as z23 } from "zod";
var assetPairConfigSchema = baseMessageSchema_default.extend({
  id: z23.string(),
  T: z23.literal(MessageType_default.ASSET_PAIR_CONFIG_UPDATE),
  k: z23.enum(["i", "u"]),
  u: z23.tuple([
    z23.string().toUpperCase(),
    // pairName
    z23.number(),
    // minQty
    z23.number().int()
    // pricePrecision
  ])
});
var assetPairConfigSchema_default = assetPairConfigSchema;

// src/services/Aggregator/ws/schemas/cfdAddressUpdateSchema.ts
import { z as z24 } from "zod";
var baseCfdAddressUpdate = baseMessageSchema_default.extend({
  id: z24.string(),
  T: z24.literal(MessageType_default.CFD_ADDRESS_UPDATE),
  S: z24.string(),
  // subscription
  uc: z24.array(z24.enum(["b", "o"]))
  // update content
});
var updateMessageSchema3 = baseCfdAddressUpdate.extend({
  k: z24.literal("u"),
  // kind of message: "u" - updates
  uc: z24.array(z24.enum(["b", "o"])),
  // update content: "o" - orders updates, "b" - balance updates
  b: cfdBalanceSchema.optional(),
  o: z24.tuple([fullOrderSchema.or(orderUpdateSchema)]).optional()
});
var initialMessageSchema3 = baseCfdAddressUpdate.extend({
  k: z24.literal("i"),
  // kind of message: "i" - initial
  b: cfdBalanceSchema,
  o: z24.array(fullOrderSchema).optional()
  // When no orders — no field
});
var cfdAddressUpdateSchema = z24.union([
  initialMessageSchema3,
  updateMessageSchema3
]);
var cfdAddressUpdateSchema_default = cfdAddressUpdateSchema;

// src/services/Aggregator/ws/schemas/isolatedCFDAddressUpdateSchema.ts
import { z as z25 } from "zod";
var baseCfdAddressUpdate2 = baseMessageSchema_default.extend({
  id: z25.string(),
  T: z25.literal(MessageType_default.ISOLATED_CFD_ADDRESS_UPDATE),
  S: z25.string(),
  // subscription
  uc: z25.array(z25.enum(["b", "o"]))
  // update content
});
var updateMessageSchema4 = baseCfdAddressUpdate2.extend({
  k: z25.literal("u"),
  // kind of message: "u" - updates
  uc: z25.array(z25.enum(["b", "o"])),
  // update content: "o" - orders updates, "b" - balance updates
  b: isolatedCFDBalancesSchema_default.optional(),
  o: z25.tuple([isolatedFullOrderSchema.or(isolatedOrderUpdateSchema)]).optional()
});
var initialMessageSchema4 = baseCfdAddressUpdate2.extend({
  k: z25.literal("i"),
  // kind of message: "i" - initial
  b: isolatedCFDBalancesSchema_default,
  o: z25.array(isolatedFullOrderSchema).optional()
  // When no orders — no field
});
var isolatedCFDAddressUpdateSchema = z25.union([
  initialMessageSchema4,
  updateMessageSchema4
]);
var isolatedCFDAddressUpdateSchema_default = isolatedCFDAddressUpdateSchema;

// src/services/Aggregator/ws/schemas/futuresTradeInfoSchema.ts
import { z as z26 } from "zod";
var futuresTradeInfoSchema = z26.object({
  T: z26.literal(MessageType_default.FUTURES_TRADE_INFO_UPDATE),
  id: z26.string(),
  // trade info request UUID, set by client side
  S: z26.string(),
  // sender
  i: z26.string(),
  // instrument
  bp: z26.number().optional(),
  // buy price
  sp: z26.number().optional(),
  // sell price
  bpw: z26.number(),
  // buy power
  spw: z26.number(),
  // sell power
  ma: z26.number()
  // min amount
});
var futuresTradeInfoSchema_default = futuresTradeInfoSchema;

// src/utils/objectKeys.ts
var objectKeys = Object.keys;

// src/services/WebsocketTransport.ts
import WebSocket from "isomorphic-ws";
import { createNanoEvents } from "nanoevents";
var WebsocketTransport = class {
  ws;
  emitter;
  address;
  options;
  constructor(address, options) {
    this.address = address;
    this.options = options;
    this.emitter = createNanoEvents();
    this.connect();
  }
  get isOpen() {
    return this.ws?.readyState === WebSocket.OPEN;
  }
  unsubscribe() {
    this.emitter.events = {};
    this.ws?.removeEventListener("open", this.handleOpen);
    this.ws?.removeEventListener("close", this.handleClose);
    this.ws?.removeEventListener("message", this.handleMessage);
    this.ws?.removeEventListener("error", this.handleError);
  }
  handleError = (error) => {
    this.emitter.emit("error", error);
  };
  handleMessage = (message) => {
    this.emitter.emit("message", message);
  };
  handleClose = (closeEvent) => {
    this.emitter.emit("close", closeEvent);
  };
  handleOpen = (openEvent) => {
    this.flushMessageQueue();
    this.emitter.emit("open", openEvent);
  };
  connect() {
    this.ws = new WebSocket(this.address, this.options);
    this.ws.addEventListener("error", this.handleError);
    this.ws.addEventListener("message", this.handleMessage);
    this.ws.addEventListener("close", this.handleClose);
    this.ws.addEventListener("open", this.handleOpen);
  }
  reconnect() {
    this.connect();
  }
  onError(errorCallback) {
    return this.emitter.on("error", errorCallback);
  }
  onMessage(messageCallback) {
    return this.emitter.on("message", messageCallback);
  }
  flushMessageQueue() {
    if (this.ws?.readyState === WebSocket.OPEN) {
      for (const message of this.messageQueue) {
        this.ws.send(message);
      }
      this.messageQueue = [];
    }
  }
  onClose(closeCallback) {
    return this.emitter.on("close", closeCallback);
  }
  onOpen(openCallback) {
    return this.emitter.on("open", openCallback);
  }
  messageQueue = [];
  sendMessage(message) {
    if (this.ws?.readyState === WebSocket.OPEN) {
      this.ws.send(message);
    } else {
      this.messageQueue.push(message);
    }
  }
  close(code, data) {
    try {
      this.ws?.close(code, data);
    } catch (e) {
      console.error(e);
    }
  }
  destroy(code, data) {
    this.close(code, data);
    this.unsubscribe();
    delete this.ws;
  }
};

// src/services/Aggregator/ws/index.ts
import { createNanoEvents as createNanoEvents2 } from "nanoevents";
var UNSUBSCRIBE = "u";
var SERVER_PING_INTERVAL = 1e4;
var HEARBEAT_THRESHOLD = 5e3;
var messageSchema = z27.union([
  initMessageSchema_default,
  pingPongMessageSchema_default,
  addressUpdateSchema_default,
  isolatedAddressUpdateSchema_default,
  cfdAddressUpdateSchema_default,
  isolatedCFDAddressUpdateSchema_default,
  assetPairsConfigSchema_default,
  assetPairConfigSchema_default,
  orderBookSchema,
  futuresTradeInfoSchema_default,
  futuresTradesStreamSchema,
  errorSchema_default2,
  unsubscriptionDoneSchema_default
]);
var exclusiveSubscriptions = [
  SubscriptionType_default.ASSET_PAIRS_CONFIG_UPDATES_SUBSCRIBE
];
var isSubType = (subType) => Object.values(SubscriptionType_default).some((t) => t === subType);
var unknownMessageTypeRegex = /An unknown message type: '(.*)', json: (.*)/;
var nonExistentMessageRegex = /Could not cancel nonexistent subscription: (.*)/;
var FUTURES_SUFFIX = "USD";
function isAllUpperCase(str) {
  return str === str.toUpperCase();
}
var AggregatorWS = class {
  transport;
  // is used to make sure we do not need to renew ws subscription
  // we can not be sure that onclose event will recieve our code when we do `ws.close(4000)`
  // since sometimes it can be replaced with system one.
  // https://stackoverflow.com/questions/19304157/getting-the-reason-why-websockets-closed-with-close-code-1006
  isClosedIntentionally = false;
  subscriptions = {};
  onInit;
  onError;
  logger;
  subIdReplacements = {};
  wsUrl;
  isAlive = false;
  get api() {
    const wsUrl = new URL(this.wsUrl);
    if (this.basicAuth) {
      wsUrl.username = this.basicAuth.username;
      wsUrl.password = this.basicAuth.password;
    }
    return wsUrl;
  }
  instanceId = uuidv4();
  basicAuth;
  emitter;
  constructor(wsUrl, basicAuth) {
    this.wsUrl = wsUrl;
    this.basicAuth = basicAuth;
    this.emitter = createNanoEvents2();
  }
  handleWsOpen = () => {
    this.setupHeartbeat();
  };
  sendRaw(data) {
    this.transport?.sendMessage(data);
  }
  send(jsonObject) {
    const jsonData = JSON.stringify(jsonObject);
    this.transport?.sendMessage(jsonData);
    this.logger?.(`Sent (${Date.now()}) : ${jsonData}`);
  }
  hearbeatIntervalId;
  setupHeartbeat() {
    const heartbeat = () => {
      if (this.isAlive) {
        this.isAlive = false;
      } else {
        this.logger?.("Heartbeat timeout");
        this.isClosedIntentionally = false;
        this.clearHeartbeat();
        this.transport?.close(4e3);
      }
    };
    this.hearbeatIntervalId = setInterval(heartbeat, SERVER_PING_INTERVAL + HEARBEAT_THRESHOLD);
  }
  clearHeartbeat() {
    this.isAlive = false;
    clearInterval(this.hearbeatIntervalId);
  }
  subscribe(type, subscription, prevSubscriptionId) {
    const id = type === "aobus" ? subscription.payload : uuidv4();
    const makeSubscription = () => {
      const isExclusive = exclusiveSubscriptions.some((t) => t === type);
      const subRequest = {};
      subRequest["T"] = type;
      subRequest["id"] = id;
      if ("payload" in subscription) {
        if (typeof subscription.payload === "string") {
          subRequest["S"] = subscription.payload;
        } else {
          subRequest["S"] = {
            d: id,
            ...subscription.payload
          };
        }
      }
      const subKey = isExclusive ? "default" : id;
      if (prevSubscriptionId === void 0) {
        const subs = this.subscriptions[type];
        if (isExclusive && subs && Object.keys(subs).length > 0) {
          throw new Error(`Subscription '${type}' already exists. Please unsubscribe first.`);
        }
        this.logger?.(`Subscribing to ${type} with id ${id}. Subscription request: ${JSON.stringify(subRequest)}`);
        this.subscriptions[type] = {
          ...this.subscriptions[type],
          [subKey]: subscription
        };
      } else {
        this.logger?.(`Resubscribing to ${type} with id ${id}. Subscription request: ${JSON.stringify(subRequest)}`);
        const prevSub = this.subscriptions[type]?.[prevSubscriptionId];
        if (prevSub) {
          this.subIdReplacements[prevSubscriptionId] = id;
          if (this.subscriptions[type]?.[prevSubscriptionId]) {
            delete this.subscriptions[type]?.[prevSubscriptionId];
          }
          this.subscriptions[type] = {
            ...this.subscriptions[type],
            [subKey]: {
              ...subscription,
              callback: prevSub.callback
            }
          };
        }
      }
      this.logger?.(`Sending subscription request: ${JSON.stringify(subRequest)}`);
      this.send(subRequest);
    };
    if (!this.transport) {
      this.init();
    }
    makeSubscription();
    return id;
  }
  /**
   * Returns newest subscription id for given id. Subscription id can be changed during resubscription.
   * This function ensure that old subscription id will be replaced with newest one.
   * @param id Id of subscription
   * @returns Newest subscription id
   */
  getNewestSubscriptionId(id) {
    const newId = this.subIdReplacements[id];
    if (newId !== void 0 && newId !== id) {
      return this.getNewestSubscriptionId(newId);
    }
    return id;
  }
  unsubscribe(subscription, details) {
    const newestSubId = this.getNewestSubscriptionId(subscription);
    this.send({
      T: UNSUBSCRIBE,
      S: newestSubId,
      ...details !== void 0 && { d: details }
    });
    const isOrderBooksSubscription = (subId) => {
      return subId.endsWith(FUTURES_SUFFIX) && !subId.includes("-") && isAllUpperCase(subId);
    };
    if (newestSubId.includes("0x")) {
      const auSubscriptions = this.subscriptions[SubscriptionType_default.ADDRESS_UPDATES_SUBSCRIBE];
      if (auSubscriptions) {
        const targetAuSub = Object.entries(auSubscriptions).find(([, value]) => value?.payload === newestSubId);
        if (targetAuSub) {
          const [key] = targetAuSub;
          delete this.subscriptions[SubscriptionType_default.ADDRESS_UPDATES_SUBSCRIBE]?.[key];
        }
      }
      const aufSubscriptions = this.subscriptions[SubscriptionType_default.CFD_ADDRESS_UPDATES_SUBSCRIBE];
      if (aufSubscriptions) {
        const targetAufSub = Object.entries(aufSubscriptions).find(([, value]) => value?.payload === newestSubId);
        if (targetAufSub) {
          const [key] = targetAufSub;
          delete this.subscriptions[SubscriptionType_default.CFD_ADDRESS_UPDATES_SUBSCRIBE]?.[key];
        }
      }
    } else if (uuidValidate(newestSubId)) {
      delete this.subscriptions[SubscriptionType_default.ASSET_PAIR_CONFIG_UPDATES_SUBSCRIBE]?.[newestSubId];
      delete this.subscriptions[SubscriptionType_default.FUTURES_TRADE_INFO_SUBSCRIBE]?.[newestSubId];
      delete this.subscriptions[SubscriptionType_default.FUTURES_TRADES_STREAM_SUBSCRIBE]?.[newestSubId];
    } else if (isOrderBooksSubscription(newestSubId)) {
      const aobSubscriptions = this.subscriptions[SubscriptionType_default.AGGREGATED_ORDER_BOOK_UPDATES_SUBSCRIBE];
      if (aobSubscriptions) {
        const targetAobSub = Object.entries(aobSubscriptions).find(([, value]) => value?.payload === newestSubId);
        if (targetAobSub) {
          const [key] = targetAobSub;
          delete this.subscriptions[SubscriptionType_default.AGGREGATED_ORDER_BOOK_UPDATES_SUBSCRIBE]?.[key];
        }
      }
    } else if (newestSubId === UnsubscriptionType_default.ASSET_PAIRS_CONFIG_UPDATES_UNSUBSCRIBE) {
      delete this.subscriptions[SubscriptionType_default.ASSET_PAIRS_CONFIG_UPDATES_SUBSCRIBE]?.["default"];
    }
  }
  destroy() {
    this.clearHeartbeat();
    this.isClosedIntentionally = true;
    this.transport?.destroy();
    delete this.transport;
  }
  // private initPromise: Promise<void> | null = null;
  // private initAsync() {
  //   if (!this.initPromise) {
  //     this.initPromise = new Promise<void>((resolve, reject) => {
  //       try {
  //         this.init();
  //         resolve();
  //       } catch (err) {
  //         reject(err);
  //       }
  //     });
  //   }
  //   return this.initPromise;
  // }
  isOpen() {
    return this.transport?.isOpen === true;
  }
  onWsOpen(openCallback) {
    return this.emitter.on("open", openCallback);
  }
  onWsClose(closeCallback) {
    return this.emitter.on("close", closeCallback);
  }
  init(isReconnect = false) {
    this.isClosedIntentionally = false;
    this.transport?.destroy();
    this.transport = new WebsocketTransport(this.api);
    this.transport.onError((err) => {
      this.onError?.(`AggregatorWS error: ${err.message}`);
      this.logger?.(`AggregatorWS: ${err.message}`);
    });
    this.transport.onClose((e) => {
      this.clearHeartbeat();
      this.transport?.unsubscribe();
      this.emitter.emit("close", e);
      this.logger?.(`AggregatorWS: connection closed ${this.isClosedIntentionally ? "intentionally" : ""}`);
      if (!this.isClosedIntentionally) {
        setTimeout(() => {
          this.init(true);
        }, 5e3);
      }
    });
    this.transport.onOpen((e) => {
      this.emitter.emit("open", e);
      this.handleWsOpen();
      if (isReconnect) {
        Object.keys(this.subscriptions).filter(isSubType).forEach((subType) => {
          const subscriptions2 = this.subscriptions[subType];
          if (subscriptions2) {
            Object.keys(subscriptions2).forEach((subId) => {
              const subPayload = subscriptions2[subId];
              this.logger?.(`AggregatorWS: reconnecting to subscription ${subType} ${subId}. Params: ${JSON.stringify(subPayload)}`);
              if (subPayload)
                this.subscribe(subType, subPayload, subId);
            });
          }
        });
      }
      this.logger?.(`AggregatorWS: connection opened${isReconnect ? " (reconnect)" : ""}`);
    });
    this.transport.onMessage((e) => {
      this.isAlive = true;
      const { data } = e;
      if (typeof data !== "string")
        throw new Error("AggregatorWS: received non-string message");
      this.logger?.(`AggregatorWS: received message: ${data}`);
      const rawJson = JSON.parse(data);
      const json = messageSchema.parse(rawJson);
      switch (json.T) {
        case MessageType_default.ERROR:
          {
            const err = errorSchema_default2.parse(json);
            const { id, m } = err;
            if (id !== void 0) {
              const nonExistentMessageMatch = m.match(nonExistentMessageRegex);
              const unknownMessageMatch = m.match(unknownMessageTypeRegex);
              if (nonExistentMessageMatch !== null) {
                const [, subscription] = nonExistentMessageMatch;
                if (subscription === void 0)
                  throw new TypeError("Subscription is undefined. This should not happen.");
                console.warn(`You tried to unsubscribe from non-existent subscription '${subscription}'. This is probably a bug in the code. Please be sure that you are unsubscribing from the subscription that you are subscribed to.`);
              } else if (unknownMessageMatch !== null) {
                const [, subscription, jsonPayload] = unknownMessageMatch;
                if (subscription === void 0)
                  throw new TypeError("Subscription is undefined. This should not happen.");
                if (jsonPayload === void 0)
                  throw new TypeError("JSON payload is undefined. This should not happen.");
                console.warn(`You tried to subscribe to '${subscription}' with unknown payload '${jsonPayload}'. This is probably a bug in the code. Please be sure that you are subscribing to the existing subscription with the correct payload.`);
              } else {
                const subType = objectKeys(this.subscriptions).find((st) => this.subscriptions[st]?.[id]);
                if (subType === void 0)
                  throw new Error(`AggregatorWS: cannot find subscription type by id ${id}. Current subscriptions: ${JSON.stringify(this.subscriptions)}`);
                const sub = this.subscriptions[subType]?.[id];
                if (sub === void 0)
                  throw new Error(`AggregatorWS: cannot find subscription by id ${id}. Current subscriptions: ${JSON.stringify(this.subscriptions)}`);
                if ("errorCb" in sub) {
                  sub.errorCb(err.m);
                }
              }
            }
            this.onError?.(err.m);
          }
          break;
        case MessageType_default.PING_PONG:
          this.sendRaw(data);
          break;
        case MessageType_default.UNSUBSCRIPTION_DONE:
          break;
        case MessageType_default.FUTURES_TRADE_INFO_UPDATE:
          this.subscriptions[SubscriptionType_default.FUTURES_TRADE_INFO_SUBSCRIBE]?.[json.id]?.callback({
            futuresTradeRequestId: json.id,
            sender: json.S,
            instrument: json.i,
            buyPrice: json.bp,
            sellPrice: json.sp,
            buyPower: json.bpw,
            sellPower: json.spw,
            minAmount: json.ma
          });
          break;
        case MessageType_default.FUTURES_TRADES_STREAM_UPDATE:
          this.subscriptions[SubscriptionType_default.FUTURES_TRADES_STREAM_SUBSCRIBE]?.[json.id]?.callback(
            {
              timestamp: json._,
              sender: json.S,
              id: json.id,
              instrument: json.i,
              side: json.s,
              positionSide: json.ps,
              amount: json.a,
              leverage: json.l,
              price: json.p,
              txHash: json.h,
              network: json.n,
              realizedPnL: json.rpnl,
              roi: json.r
            }
          );
          break;
        case MessageType_default.INITIALIZATION:
          this.onInit?.();
          break;
        case MessageType_default.AGGREGATED_ORDER_BOOK_UPDATE:
          {
            const { ob, S } = json;
            const mapOrderbookItems = (rawItems) => rawItems.reduce((acc, item) => {
              const [
                price,
                amount,
                vob
              ] = item;
              acc.push({
                price,
                amount,
                vob: vob.map(([side, pairName]) => ({
                  side,
                  pairName
                }))
              });
              return acc;
            }, []);
            this.subscriptions[SubscriptionType_default.AGGREGATED_ORDER_BOOK_UPDATES_SUBSCRIBE]?.[json.S]?.callback(
              mapOrderbookItems(ob.a),
              mapOrderbookItems(ob.b),
              S
            );
          }
          break;
        case MessageType_default.ASSET_PAIR_CONFIG_UPDATE: {
          const pair = json.u;
          const [, minQty, pricePrecision] = pair;
          this.subscriptions[SubscriptionType_default.ASSET_PAIR_CONFIG_UPDATES_SUBSCRIBE]?.[json.id]?.callback({
            data: {
              minQty,
              pricePrecision
            },
            kind: json.k === "i" ? "initial" : "update"
          });
          break;
        }
        case MessageType_default.ASSET_PAIRS_CONFIG_UPDATE:
          {
            const pairs = json;
            const priceUpdates = {};
            pairs.u.forEach(([pairName, minQty, pricePrecision]) => {
              priceUpdates[pairName] = {
                minQty,
                pricePrecision
              };
            });
            this.subscriptions[SubscriptionType_default.ASSET_PAIRS_CONFIG_UPDATES_SUBSCRIBE]?.["default"]?.callback({
              kind: json.k === "i" ? "initial" : "update",
              data: priceUpdates
            });
          }
          break;
        case MessageType_default.CFD_ADDRESS_UPDATE:
          switch (json.k) {
            case "i":
              {
                const fullOrders = json.o ? json.o.reduce((prev, o) => {
                  prev.push(o);
                  return prev;
                }, []) : void 0;
                this.subscriptions[SubscriptionType_default.CFD_ADDRESS_UPDATES_SUBSCRIBE]?.[json.id]?.callback({
                  kind: "initial",
                  orders: fullOrders,
                  balance: json.b
                });
              }
              break;
            case "u":
              {
                let orderUpdate;
                if (json.o) {
                  const firstOrder = json.o[0];
                  orderUpdate = firstOrder;
                }
                this.subscriptions[SubscriptionType_default.CFD_ADDRESS_UPDATES_SUBSCRIBE]?.[json.id]?.callback({
                  kind: "update",
                  order: orderUpdate,
                  balance: json.b
                });
              }
              break;
            default:
              break;
          }
          break;
        case MessageType_default.ISOLATED_CFD_ADDRESS_UPDATE:
          switch (json.k) {
            case "i":
              {
                const isolatedFullOrders = json.o ? json.o.reduce((prev, o) => {
                  prev.push(o);
                  return prev;
                }, []) : void 0;
                this.subscriptions[SubscriptionType_default.ISOLATED_CFD_ADDRESS_UPDATES_SUBSCRIBE]?.[json.id]?.callback({
                  kind: "initial",
                  orders: isolatedFullOrders,
                  balances: json.b
                });
              }
              break;
            case "u":
              {
                let isolatedOrderUpdate;
                if (json.o) {
                  const isolatedFirstOrder = json.o[0];
                  isolatedOrderUpdate = isolatedFirstOrder;
                }
                this.subscriptions[SubscriptionType_default.ISOLATED_CFD_ADDRESS_UPDATES_SUBSCRIBE]?.[json.id]?.callback({
                  kind: "update",
                  order: isolatedOrderUpdate,
                  balances: json.b
                });
              }
              break;
            default:
              break;
          }
          break;
        case MessageType_default.ADDRESS_UPDATE:
          {
            const balances = json.b ? Object.entries(json.b).reduce((prev, [asset, assetBalances]) => {
              if (!assetBalances)
                return prev;
              const [tradable, reserved, contract, wallet, allowance] = assetBalances;
              prev[asset] = {
                tradable,
                reserved,
                contract,
                wallet,
                allowance
              };
              return prev;
            }, {}) : {};
            switch (json.k) {
              case "i":
                {
                  const fullOrders = json.o ? json.o.reduce((prev, o) => {
                    prev.push(o);
                    return prev;
                  }, []) : void 0;
                  this.subscriptions[SubscriptionType_default.ADDRESS_UPDATES_SUBSCRIBE]?.[json.id]?.callback({
                    kind: "initial",
                    orders: fullOrders,
                    balances
                  });
                }
                break;
              case "u":
                {
                  let orderUpdate;
                  if (json.o) {
                    const firstOrder = json.o[0];
                    orderUpdate = firstOrder;
                  }
                  this.subscriptions[SubscriptionType_default.ADDRESS_UPDATES_SUBSCRIBE]?.[json.id]?.callback({
                    kind: "update",
                    order: orderUpdate,
                    balances
                  });
                }
                break;
              default:
                break;
            }
          }
          break;
        case MessageType_default.ISOLATED_ADDRESS_UPDATE:
          {
            const balances = json.b ? Object.entries(json.b).reduce((prev, [asset, assetBalances]) => {
              if (!assetBalances)
                return prev;
              const [tradable, reserved, contract, wallet, allowance] = assetBalances;
              prev[asset] = {
                tradable,
                reserved,
                contract,
                wallet,
                allowance
              };
              return prev;
            }, {}) : {};
            switch (json.k) {
              case "i":
                {
                  const isolatedFullOrders = json.o ? json.o.reduce((prev, o) => {
                    prev.push(o);
                    return prev;
                  }, []) : void 0;
                  this.subscriptions[SubscriptionType_default.ISOLATED_ADDRESS_UPDATES_SUBSCRIBE]?.[json.id]?.callback({
                    kind: "initial",
                    orders: isolatedFullOrders,
                    balances
                  });
                }
                break;
              case "u":
                {
                  let isolatedOrderUpdate;
                  if (json.o) {
                    const isolatedFirstOrder = json.o[0];
                    isolatedOrderUpdate = isolatedFirstOrder;
                  }
                  this.subscriptions[SubscriptionType_default.ISOLATED_ADDRESS_UPDATES_SUBSCRIBE]?.[json.id]?.callback({
                    kind: "update",
                    order: isolatedOrderUpdate,
                    balances
                  });
                }
                break;
              default:
                break;
            }
          }
          break;
        default:
          break;
      }
    });
  }
};

// src/services/Aggregator/schemas/index.ts
var schemas_exports3 = {};
__export(schemas_exports3, {
  cancelOrderSchema: () => cancelOrderSchema_default,
  errorSchema: () => errorSchema_default,
  exchangeInfoSchema: () => exchangeInfoSchema_default,
  futuresBalancesSchema: () => futuresBalancesSchema_default,
  orderSchema: () => orderSchema_default,
  pairConfigSchema: () => pairConfigSchema_default
});

// src/services/Aggregator/schemas/orderSchema.ts
import { ethers as ethers6 } from "ethers";
import { z as z28 } from "zod";
var blockchainOrderSchema = z28.object({
  id: z28.string().refine(ethers6.isHexString, (value) => ({
    message: `blockchainOrder.id must be a hex string, got ${value}`
  })),
  senderAddress: z28.string().refine(ethers6.isAddress, (value) => ({
    message: `blockchainOrder.senderAddress must be an address, got ${value}`
  })),
  matcherAddress: z28.string().refine(ethers6.isAddress, (value) => ({
    message: `blockchainOrder.matcherAddress must be an address, got ${value}`
  })),
  baseAsset: z28.string().refine(ethers6.isAddress, (value) => ({
    message: `blockchainOrder.baseAsset must be an address, got ${value}`
  })),
  quoteAsset: z28.string().refine(ethers6.isAddress, (value) => ({
    message: `blockchainOrder.quoteAsset must be an address, got ${value}`
  })),
  matcherFeeAsset: z28.string().refine(ethers6.isAddress, (value) => ({
    message: `blockchainOrder.matcherFeeAsset must be an address, got ${value}`
  })),
  amount: z28.number().int().nonnegative(),
  price: z28.number().int().nonnegative(),
  matcherFee: z28.number().int().nonnegative(),
  nonce: z28.number(),
  expiration: z28.number(),
  buySide: z28.union([z28.literal(1), z28.literal(0)]),
  signature: z28.string().refine(ethers6.isHexString, (value) => ({
    message: `blockchainOrder.signature must be a hex string, got ${value}`
  })).nullable(),
  isPersonalSign: z28.boolean(),
  needWithdraw: z28.boolean()
});
var tradeInfoSchema = z28.object({
  tradeId: z28.string().uuid(),
  tradeStatus: z28.enum(["NEW", "PENDING", "OK", "FAIL", "TEMP_ERROR", "REJECTED"]),
  filledAmount: z28.number().nonnegative(),
  price: z28.number().nonnegative(),
  creationTime: z28.number(),
  updateTime: z28.number(),
  matchedBlockchainOrder: blockchainOrderSchema.optional(),
  matchedSubOrderId: z28.number().int().nonnegative().optional(),
  exchangeTradeInfo: z28.boolean(),
  poolTradeInfo: z28.boolean()
});
var baseOrderSchema = z28.object({
  assetPair: z28.string().toUpperCase(),
  side: z28.enum(["BUY", "SELL"]),
  amount: z28.number().nonnegative(),
  remainingAmount: z28.number().nonnegative(),
  price: z28.number().nonnegative(),
  sender: z28.string().refine(ethers6.isAddress, (value) => ({
    message: `order.sender must be an address, got ${value}`
  })),
  filledAmount: z28.number().nonnegative(),
  internalOnly: z28.boolean()
});
var brokerAddressSchema = z28.enum(["INTERNAL_BROKER", "SELF_BROKER"]).or(z28.string().refine(ethers6.isAddress, (value) => ({
  message: `subOrder.subOrders.[n].brokerAddress must be an address, got ${value}`
})));
var subOrderSchema2 = baseOrderSchema.extend({
  price: z28.number(),
  id: z28.number(),
  parentOrderId: z28.string().refine(ethers6.isHexString, (value) => ({
    message: `subOrder.parentOrderId must be a hex string, got ${value}`
  })),
  brokerAddress: brokerAddressSchema,
  tradesInfo: z28.record(
    z28.string().uuid(),
    tradeInfoSchema
  ),
  status: z28.enum(subOrderStatuses_default),
  complexSwap: z28.boolean()
});
var orderSchema = z28.object({
  orderId: z28.string().refine(ethers6.isHexString, (value) => ({
    message: `orderId must be a hex string, got ${value}`
  })),
  order: baseOrderSchema.extend({
    id: z28.string().refine(ethers6.isHexString, (value) => ({
      message: `order.id must be a hex string, got ${value}`
    })),
    fee: z28.number().nonnegative(),
    feeAsset: z28.string().toUpperCase(),
    creationTime: z28.number(),
    blockchainOrder: blockchainOrderSchema,
    subOrders: z28.record(subOrderSchema2),
    updateTime: z28.number(),
    status: z28.enum(orderStatuses_default),
    settledAmount: z28.number().nonnegative()
  })
});
var orderSchema_default = orderSchema;

// src/services/Aggregator/schemas/futuresBalancesSchema.ts
import { z as z29 } from "zod";
var futuresBalancesSchema = z29.object({
  address: z29.string(),
  balance: z29.number(),
  statesByInstruments: z29.record(z29.object({
    instrument: z29.string(),
    position: z29.number(),
    positionStatus: z29.string(),
    positionPrice: z29.number(),
    currentPrice: z29.number(),
    oraclePrice: z29.number(),
    leverage: z29.number(),
    fundingRateFee: z29.number(),
    fundingRateFeeUSD: z29.number(),
    floatingPnL: z29.number(),
    margin: z29.number(),
    marginUSD: z29.number(),
    oraclePriceDeviationPercentage: z29.number()
  }))
});
var futuresBalancesSchema_default = futuresBalancesSchema;

// src/utils/httpToWS.ts
var httpToWS = (url) => {
  let parsedUrl;
  try {
    parsedUrl = new URL(url);
  } catch (e) {
    console.error(`httpToWS: Invalid URL ${url}`);
    throw e;
  }
  if (parsedUrl.protocol === "https:") {
    parsedUrl.protocol = "wss:";
  } else if (parsedUrl.protocol === "http:") {
    parsedUrl.protocol = "ws:";
  }
  return parsedUrl.toString();
};
var httpToWS_default = httpToWS;

// src/services/Aggregator/index.ts
import { ethers as ethers7 } from "ethers";
import { fetchWithValidation } from "simple-typed-fetch";
var Aggregator = class {
  apiUrl;
  ws;
  basicAuth;
  get api() {
    return this.apiUrl;
  }
  constructor(httpAPIUrl, wsAPIUrl, basicAuth) {
    this.apiUrl = httpAPIUrl;
    this.ws = new AggregatorWS(httpToWS_default(wsAPIUrl));
    this.basicAuth = basicAuth;
    this.getPairConfig = this.getPairConfig.bind(this);
    this.getPairConfigs = this.getPairConfigs.bind(this);
    this.getPairsList = this.getPairsList.bind(this);
    this.placeOrder = this.placeOrder.bind(this);
    this.placeCFDOrder = this.placeCFDOrder.bind(this);
    this.placeCrossMarginOrder = this.placeCrossMarginOrder.bind(this);
    this.cancelOrder = this.cancelOrder.bind(this);
    this.checkWhitelisted = this.checkWhitelisted.bind(this);
    this.getLockedBalance = this.getLockedBalance.bind(this);
    this.getVersion = this.getVersion.bind(this);
    this.getPrices = this.getPrices.bind(this);
  }
  get basicAuthHeaders() {
    if (this.basicAuth) {
      return {
        Authorization: `Basic ${btoa(`${this.basicAuth.username}:${this.basicAuth.password}`)}`
      };
    }
    return {};
  }
  getOrder = (orderId, owner) => {
    if (!ethers7.isHexString(orderId)) {
      throw new Error(`Invalid order id: ${orderId}. Must be a hex string`);
    }
    const url = new URL(`${this.apiUrl}/api/v1/order`);
    url.searchParams.append("orderId", orderId);
    if (owner !== void 0) {
      if (!ethers7.isAddress(owner)) {
        throw new Error(`Invalid owner address: ${owner}`);
      }
      url.searchParams.append("owner", owner);
    }
    return fetchWithValidation(
      url.toString(),
      orderSchema_default,
      { headers: this.basicAuthHeaders },
      errorSchema_default
    );
  };
  getPrices = (assetPair) => {
    const url = new URL(`${this.apiUrl}/api/v1/prices/`);
    url.searchParams.append("assetPair", assetPair);
    return fetchWithValidation(
      url.toString(),
      z30.number(),
      { headers: this.basicAuthHeaders },
      errorSchema_default
    );
  };
  getPairsList = (market) => {
    const url = new URL(`${this.apiUrl}/api/v1/pairs/list`);
    url.searchParams.append("market", toUpperCase(market));
    return fetchWithValidation(
      url.toString(),
      z30.array(z30.string().toUpperCase()),
      { headers: this.basicAuthHeaders }
    );
  };
  getPairConfigs = (market) => {
    const url = new URL(`${this.apiUrl}/api/v1/pairs/exchangeInfo`);
    url.searchParams.append("market", toUpperCase(market));
    return fetchWithValidation(
      url.toString(),
      exchangeInfoSchema_default,
      { headers: this.basicAuthHeaders },
      errorSchema_default
    );
  };
  getVersion = () => fetchWithValidation(
    `${this.apiUrl}/api/v1/version`,
    z30.object({
      serviceName: z30.string(),
      version: z30.string(),
      apiVersion: z30.string()
    }),
    { headers: this.basicAuthHeaders },
    errorSchema_default
  );
  getPairConfig = (assetPair) => fetchWithValidation(
    `${this.apiUrl}/api/v1/pairs/exchangeInfo/${assetPair}`,
    pairConfigSchema_default,
    { headers: this.basicAuthHeaders },
    errorSchema_default
  );
  checkWhitelisted = (address) => fetchWithValidation(
    `${this.apiUrl}/api/v1/whitelist/check?address=${address}`,
    z30.boolean(),
    { headers: this.basicAuthHeaders },
    errorSchema_default
  );
  placeOrder = (signedOrder, isCreateInternalOrder, partnerId) => {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...partnerId !== void 0 && { "X-Partner-Id": partnerId },
      ...this.basicAuthHeaders
    };
    const url = new URL(`${this.apiUrl}/api/v1/order/${isCreateInternalOrder ? "internal" : ""}`);
    return fetchWithValidation(
      url.toString(),
      z30.object({
        orderId: z30.string(),
        placementRequests: z30.array(
          z30.object({
            amount: z30.number(),
            brokerAddress: z30.string(),
            exchange: z30.string()
          })
        ).optional()
      }),
      {
        headers,
        method: "POST",
        body: JSON.stringify(signedOrder)
      },
      errorSchema_default
    );
  };
  cancelOrder = (signedCancelOrderRequest) => fetchWithValidation(
    `${this.apiUrl}/api/v1/order`,
    cancelOrderSchema_default,
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...this.basicAuthHeaders
      },
      body: JSON.stringify({
        ...signedCancelOrderRequest,
        sender: signedCancelOrderRequest.senderAddress
      })
    },
    errorSchema_default
  );
  placeCFDOrder = (signedOrder, isReversedOrder) => {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...isReversedOrder !== void 0 && {
        "X-Reverse-Order": isReversedOrder ? "true" : "false"
      },
      ...this.basicAuthHeaders
    };
    return fetchWithValidation(
      `${this.apiUrl}/api/v1/order/futures`,
      z30.object({
        orderId: z30.string(),
        placementRequests: z30.array(
          z30.object({
            amount: z30.number(),
            brokerAddress: z30.string(),
            exchange: z30.string()
          })
        ).optional()
      }),
      {
        headers,
        method: "POST",
        body: JSON.stringify(signedOrder)
      },
      errorSchema_default
    );
  };
  placeCrossMarginOrder = (signedOrder) => {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...this.basicAuthHeaders
    };
    return fetchWithValidation(
      `${this.apiUrl}/api/v1/order/futures`,
      z30.object({
        orderId: z30.string(),
        placementRequests: z30.array(
          z30.object({
            amount: z30.number(),
            brokerAddress: z30.string(),
            exchange: z30.string()
          })
        ).optional()
      }),
      {
        headers,
        method: "POST",
        body: JSON.stringify(signedOrder)
      },
      errorSchema_default
    );
  };
  getBalance = (address) => {
    const url = new URL(`${this.apiUrl}/api/v1/address/futures/balance/${address}`);
    return fetchWithValidation(
      url.toString(),
      futuresBalancesSchema_default
    );
  };
  getLockedBalance = (address, currency) => {
    const url = new URL(`${this.apiUrl}/api/v1/address/balance/reserved/${currency}`);
    url.searchParams.append("address", address);
    return fetchWithValidation(
      url.toString(),
      z30.object({
        [currency]: z30.number()
      }).partial(),
      { headers: this.basicAuthHeaders },
      errorSchema_default
    );
  };
};

// src/services/BlockchainService/index.ts
var BlockchainService_exports = {};
__export(BlockchainService_exports, {
  BlockchainService: () => BlockchainService,
  schemas: () => schemas_exports4
});
import { z as z40 } from "zod";
import { fetchWithValidation as fetchWithValidation2 } from "simple-typed-fetch";

// src/services/BlockchainService/schemas/index.ts
var schemas_exports4 = {};
__export(schemas_exports4, {
  baseLimitsSchema: () => baseLimitsSchema_default,
  cfdContractsSchema: () => cfdContractsSchema_default,
  cfdHistorySchema: () => cfdHistorySchema,
  crossMarginHistorySchema: () => crossMarginHistorySchema,
  crossMarginInfoSchema: () => crossMarginInfoSchema_default,
  governanceChainsInfoSchema: () => governanceChainsInfoSchema_default,
  governanceContractsSchema: () => governanceContractsSchema_default,
  historySchema: () => historySchema_default,
  infoSchema: () => infoSchema_default,
  pricesWithQuoteAssetSchema: () => pricesWithQuoteAssetSchema
});

// src/services/BlockchainService/schemas/historySchema.ts
import { z as z31 } from "zod";
var historySchema = z31.array(z31.object(
  {
    amount: z31.string(),
    amountNumber: z31.string(),
    asset: z31.string(),
    assetAddress: z31.string(),
    contractBalance: z31.string().nullable().optional(),
    createdAt: z31.number(),
    transactionHash: z31.string(),
    type: z31.enum(["deposit", "withdrawal"]),
    user: z31.string(),
    walletBalance: z31.string().nullable().optional()
  }
)).transform((response) => {
  return response.map((item) => {
    const {
      type,
      createdAt,
      transactionHash,
      user
    } = item;
    return {
      type,
      date: createdAt * 1e3,
      token: item.asset,
      amount: item.amountNumber,
      status: "Done" /* DONE */,
      transactionHash,
      user
    };
  });
});
var historySchema_default = historySchema;

// src/services/BlockchainService/schemas/infoSchema.ts
import { z as z32 } from "zod";
var internalFeeAssetSchema = z32.object({
  type: z32.enum(["percent", "plain"]),
  value: z32.number(),
  asset: z32.string()
});
var infoSchema = z32.object({
  chainId: z32.number(),
  chainName: z32.string(),
  exchangeContractAddress: z32.string(),
  oracleContractAddress: z32.string(),
  matcherAddress: z32.string(),
  orderFeePercent: z32.number(),
  assetToAddress: z32.record(z32.string()).transform(makePartial),
  assetToDecimals: z32.record(z32.number()).transform(makePartial),
  assetToIcons: z32.record(z32.string()).transform(makePartial).optional(),
  cexTokens: z32.string().array(),
  internalFeeAssets: internalFeeAssetSchema.array().optional()
});
var infoSchema_default = infoSchema;

// src/services/BlockchainService/schemas/cfdContractsSchema.ts
import { z as z33 } from "zod";
var cfdContractsSchema = z33.array(z33.object({
  name: z33.string(),
  alias: z33.string(),
  address: z33.string(),
  leverage: z33.number(),
  soLevel: z33.number(),
  shortFR: z33.number(),
  longFR: z33.number(),
  shortFRStored: z33.number(),
  longFRStored: z33.number(),
  lastFRPriceUpdateTime: z33.number(),
  priceIndex: z33.number(),
  feePercent: z33.number(),
  withdrawMarginLevel: z33.number(),
  delegateContractAddress: z33.string()
}));
var cfdContractsSchema_default = cfdContractsSchema;

// src/services/BlockchainService/schemas/cfdHistorySchema.ts
import { z as z34 } from "zod";
var historyTransactionType = /* @__PURE__ */ ((historyTransactionType2) => {
  historyTransactionType2["WITHDRAW"] = "withdrawal";
  historyTransactionType2["DEPOSIT"] = "deposit";
  return historyTransactionType2;
})(historyTransactionType || {});
var baseHistoryItem = z34.object({
  _id: z34.string(),
  __v: z34.number(),
  address: z34.string(),
  balance: z34.string(),
  amount: z34.string(),
  amountNumber: z34.string(),
  reason: z34.enum(["WITHDRAW", "DEPOSIT"]),
  transactionHash: z34.string(),
  blockNumber: z34.number(),
  createdAt: z34.number()
});
var baseHistorySchema = z34.object({
  success: z34.boolean(),
  count: z34.number(),
  total: z34.number(),
  pagination: z34.object({})
});
var cfdHistory = baseHistorySchema.extend({
  data: z34.array(baseHistoryItem.extend({
    instrumentAddress: z34.string(),
    instrument: z34.string(),
    position: z34.string(),
    positionPrice: z34.string(),
    fundingRate: z34.string()
  }))
});
var crossMarginHistory = baseHistorySchema.extend({
  data: z34.array(baseHistoryItem)
});
var baseHistoryItemTransform = (item) => {
  const { createdAt, reason, transactionHash, amountNumber } = item;
  const type = historyTransactionType[reason];
  const result = {
    type,
    date: createdAt,
    token: "USDT",
    amount: amountNumber,
    status: "Done" /* DONE */,
    transactionHash,
    user: item.address
  };
  return result;
};
var cfdHistoryTransform = (response) => response.data.map(({
  instrumentAddress,
  instrument,
  position,
  positionPrice,
  fundingRate,
  ...item
}) => ({
  ...baseHistoryItemTransform(item),
  instrumentAddress,
  instrument,
  position,
  positionPrice,
  fundingRate
}));
var crossMarginHistoryTransform = (response) => response.data.map(baseHistoryItemTransform);
var cfdHistorySchema = cfdHistory.transform(cfdHistoryTransform);
var crossMarginHistorySchema = crossMarginHistory.transform(
  crossMarginHistoryTransform
);

// src/services/BlockchainService/schemas/governanceContractsSchema.ts
import { z as z35 } from "zod";
var governanceContractsSchema = z35.object({
  controllerAddress: z35.string(),
  veTOKENAddress: z35.string(),
  veTOKENYieldDistributorV4Address: z35.string(),
  tokenGaugeTOKENRewardsDistributorAddress: z35.string(),
  time_total: z35.string(),
  absolute_ve_token_in_voting: z35.string(),
  info: z35.record(
    z35.string(),
    z35.object({
      gaugeAddress: z35.string(),
      gaugeType: z35.number(),
      gaugeName: z35.string()
    })
  )
});
var governanceContractsSchema_default = governanceContractsSchema;

// src/services/BlockchainService/schemas/governanceChainsInfoSchema.ts
import { z as z36 } from "zod";
var governanceChainsInfoSchema = z36.object({
  isChainSupported: z36.boolean()
});
var governanceChainsInfoSchema_default = governanceChainsInfoSchema;

// src/services/BlockchainService/schemas/crossMarginInfoSchema.ts
import { z as z37 } from "zod";
var crossMarginCFDItemInfo = z37.object({
  id: z37.number(),
  name: z37.string(),
  leverage: z37.number(),
  longFR: z37.number(),
  shortFR: z37.number(),
  longFRStored: z37.number(),
  shortFRStored: z37.number(),
  lastFRPriceUpdateTime: z37.number(),
  feePercent: z37.number()
});
var crossMarginInfoSchema = z37.object({
  address: z37.string().optional(),
  oracleAddress: z37.string().optional(),
  withdrawMarginLevel: z37.number().optional(),
  fundingRateAccount: z37.string().optional(),
  soLevel: z37.number().optional(),
  delegateContractAddress: z37.string().optional(),
  instruments: z37.record(z37.string(), crossMarginCFDItemInfo)
});
var crossMarginInfoSchema_default = crossMarginInfoSchema;

// src/services/BlockchainService/schemas/baseLimitsSchema.ts
import { z as z38 } from "zod";
var baseLimitsSchema = z38.object({
  FILL_CFD_ORDERS_TRADE_GAS_LIMIT: z38.number().int(),
  WITHDRAW_GAS_LIMIT: z38.number().int(),
  DEPOSIT_ETH_GAS_LIMIT: z38.number().int(),
  DEPOSIT_ERC20_GAS_LIMIT: z38.number().int(),
  APPROVE_ERC20_GAS_LIMIT: z38.number().int()
});
var baseLimitsSchema_default = baseLimitsSchema;

// src/services/BlockchainService/schemas/pricesWithQuoteAssetSchema.ts
import { z as z39 } from "zod";
var pricesWithQuoteAssetSchema = z39.object({
  quoteAsset: z39.string(),
  quoteAssetAddress: z39.string(),
  prices: z39.record(z39.string()).transform(makePartial)
});

// src/services/BlockchainService/index.ts
var BlockchainService = class {
  apiUrl;
  basicAuth;
  get api() {
    return this.apiUrl;
  }
  constructor(apiUrl, basicAuth) {
    this.apiUrl = apiUrl;
    this.basicAuth = basicAuth;
    this.getInfo = this.getInfo.bind(this);
    this.getHistory = this.getHistory.bind(this);
    this.getPrices = this.getPrices.bind(this);
    this.getPricesWithQuoteAsset = this.getPricesWithQuoteAsset.bind(this);
    this.getGasPriceWei = this.getGasPriceWei.bind(this);
    this.getBlockNumber = this.getBlockNumber.bind(this);
    this.getCFDContracts = this.getCFDContracts.bind(this);
    this.getCFDHistory = this.getCFDHistory.bind(this);
    this.getCrossMarginHistory = this.getCrossMarginHistory.bind(this);
    this.getCrossMarginInfo = this.getCrossMarginInfo.bind(this);
    this.getGovernanceContracts = this.getGovernanceContracts.bind(this);
    this.getGovernanceChainsInfo = this.getGovernanceChainsInfo.bind(this);
    this.getBaseLimits = this.getBaseLimits.bind(this);
  }
  get basicAuthHeaders() {
    if (this.basicAuth) {
      return {
        Authorization: `Basic ${btoa(`${this.basicAuth.username}:${this.basicAuth.password}`)}`
      };
    }
    return {};
  }
  get blockchainServiceWsUrl() {
    return `${this.apiUrl}/`;
  }
  getQueueLength = () => fetchWithValidation2(
    `${this.apiUrl}/api/queueLength`,
    z40.number().int(),
    { headers: this.basicAuthHeaders }
  );
  get internal() {
    return {
      getQueueLength: this.getQueueLength.bind(this)
    };
  }
  getInfo = () => fetchWithValidation2(`${this.apiUrl}/api/info`, infoSchema_default);
  getBaseLimits = () => fetchWithValidation2(
    `${this.apiUrl}/api/baseLimits`,
    baseLimitsSchema_default,
    { headers: this.basicAuthHeaders }
  );
  getHistory = (address) => fetchWithValidation2(
    `${this.apiUrl}/api/history/${address}`,
    historySchema_default,
    { headers: this.basicAuthHeaders }
  );
  getPrices = () => fetchWithValidation2(
    `${this.apiUrl}/api/prices`,
    z40.record(z40.string()).transform(makePartial),
    { headers: this.basicAuthHeaders }
  );
  getPricesWithQuoteAsset = () => fetchWithValidation2(
    `${this.apiUrl}/api/quotedPrices`,
    pricesWithQuoteAssetSchema,
    { headers: this.basicAuthHeaders }
  );
  getCFDPrices = () => fetchWithValidation2(
    `${this.apiUrl}/api/cfd/prices`,
    pricesWithQuoteAssetSchema,
    { headers: this.basicAuthHeaders }
  );
  getCrossMarginCFDPrices = () => fetchWithValidation2(
    `${this.apiUrl}/api/cfd/cross-margin/prices`,
    pricesWithQuoteAssetSchema,
    { headers: this.basicAuthHeaders }
  );
  getGasPriceWei = () => fetchWithValidation2(
    `${this.apiUrl}/api/gasPrice`,
    z40.string(),
    { headers: this.basicAuthHeaders }
  );
  getBlockNumber = () => fetchWithValidation2(
    `${this.apiUrl}/api/blocknumber`,
    z40.number().int(),
    { headers: this.basicAuthHeaders }
  );
  getCFDContracts = () => fetchWithValidation2(
    `${this.apiUrl}/api/cfd/contracts`,
    cfdContractsSchema_default,
    { headers: this.basicAuthHeaders }
  );
  getGovernanceContracts = () => fetchWithValidation2(
    `${this.apiUrl}/api/governance/info`,
    governanceContractsSchema_default,
    { headers: this.basicAuthHeaders }
  );
  getGovernanceChainsInfo = () => fetchWithValidation2(
    `${this.apiUrl}/api/governance/chains-info`,
    governanceChainsInfoSchema_default,
    { headers: this.basicAuthHeaders }
  );
  getCFDHistory = (address, query = {}) => {
    const url = new URL(`${this.apiUrl}/api/cfd/deposit-withdraw/${address}`);
    Object.entries(query).forEach(([key, value]) => {
      if (value === void 0)
        throw new Error("Value must be defined");
      url.searchParams.append(key, value.toString());
    });
    return fetchWithValidation2(
      url.toString(),
      cfdHistorySchema,
      { headers: this.basicAuthHeaders }
    );
  };
  getCrossMarginInfo = () => fetchWithValidation2(
    `${this.apiUrl}/api/cfd/cross-margin/info`,
    crossMarginInfoSchema_default,
    { headers: this.basicAuthHeaders }
  );
  getCrossMarginHistory = (address, query = {}) => {
    const url = new URL(`${this.apiUrl}/api/cfd/cross-margin/deposit-withdraw/${address}`);
    Object.entries(query).forEach(([key, value]) => {
      if (value === void 0)
        throw new Error("Value must be defined");
      url.searchParams.append(key, value.toString());
    });
    return fetchWithValidation2(
      url.toString(),
      crossMarginHistorySchema,
      { headers: this.basicAuthHeaders }
    );
  };
};

// src/services/PriceFeed/index.ts
var PriceFeed_exports = {};
__export(PriceFeed_exports, {
  PriceFeed: () => PriceFeed,
  schemas: () => schemas_exports5,
  ws: () => ws_exports2
});
import { fetchWithValidation as fetchWithValidation3 } from "simple-typed-fetch";

// src/services/PriceFeed/schemas/index.ts
var schemas_exports5 = {};
__export(schemas_exports5, {
  allTickersSchema: () => allTickersSchema,
  candlesSchema: () => candlesSchema_default,
  leaderboardSchema: () => leaderboardSchema,
  statisticsOverviewSchema: () => statisticsOverviewSchema,
  topPairsSchema: () => topPairsSchema,
  winnersSchema: () => winnersSchema
});

// src/services/PriceFeed/schemas/candlesSchema.ts
import { z as z41 } from "zod";
var candlesSchema = z41.object({
  candles: z41.array(z41.object({
    close: z41.string(),
    high: z41.string(),
    low: z41.string(),
    open: z41.string(),
    time: z41.number(),
    timeEnd: z41.number(),
    timeStart: z41.number(),
    volume: z41.string()
  })),
  timeStart: z41.number(),
  timeEnd: z41.number()
});
var candlesSchema_default = candlesSchema;

// src/services/PriceFeed/schemas/allTickersSchema.ts
import { z as z42 } from "zod";
var allTickersSchema = z42.object({
  pair: z42.string(),
  volume24: z42.number(),
  change24: z42.number(),
  lastPrice: z42.number()
}).array();

// src/services/PriceFeed/schemas/leaderboardSchema.ts
import { z as z43 } from "zod";
var leaderboardSchema = z43.object({
  address: z43.string(),
  totalVolume: z43.number(),
  todayVolume: z43.number(),
  totalPnl: z43.number(),
  todayPnl: z43.number(),
  totalRoi: z43.number(),
  todayRoi: z43.number()
}).array();

// src/services/PriceFeed/schemas/statisticsOverviewSchema.ts
import { z as z44 } from "zod";
var statisticsOverviewSchema = z44.object({
  time: z44.number(),
  statisticsOverview: z44.object({
    volume24h: z44.number(),
    volume7d: z44.number(),
    volumeAllTime: z44.number()
  })
});

// src/services/PriceFeed/schemas/topPairsSchema.ts
import { z as z45 } from "zod";
var topPairsSchema = z45.object({
  time: z45.number(),
  topPairs: z45.array(
    z45.object({
      assetPair: z45.string(),
      statisticsOverview: z45.object({
        volume24h: z45.number(),
        volume7d: z45.number()
      })
    })
  )
});

// src/services/PriceFeed/schemas/winnersSchema.ts
import { z as z46 } from "zod";
var winnersSchema = z46.object({
  bestTrade: z46.object({
    address: z46.string(),
    instrument: z46.string(),
    leverage: z46.number(),
    pnl: z46.number(),
    side: z46.string()
  }),
  worstTrade: z46.object({
    address: z46.string(),
    instrument: z46.string(),
    leverage: z46.number(),
    pnl: z46.number(),
    side: z46.string()
  }),
  bestPnl: z46.object({ address: z46.string(), pnl: z46.number() }),
  worstPnl: z46.object({ address: z46.string(), pnl: z46.number() })
});

// src/services/PriceFeed/ws/index.ts
var ws_exports2 = {};
__export(ws_exports2, {
  PriceFeedWS: () => PriceFeedWS,
  schemas: () => schemas_exports6
});

// src/services/PriceFeed/ws/PriceFeedSubscription.ts
import WebSocket2 from "isomorphic-ws";
import { z as z51 } from "zod";
import { v4 as uuidv42 } from "uuid";

// src/services/PriceFeed/ws/priceFeedSubscriptions.ts
var priceFeedSubscriptions = {
  TICKER: "ticker",
  ALL_TICKERS: "allTickers",
  LAST_PRICE: "lastPrice",
  CANDLE: "candle"
};
var priceFeedSubscriptions_default = priceFeedSubscriptions;

// src/services/PriceFeed/ws/schemas/index.ts
var schemas_exports6 = {};
__export(schemas_exports6, {
  allTickersSchema: () => allTickersSchema_default,
  candleSchema: () => candleSchema_default,
  priceSchema: () => priceSchema_default,
  tickerInfoSchema: () => tickerInfoSchema_default
});

// src/services/PriceFeed/ws/schemas/tickerInfoSchema.ts
import { z as z47 } from "zod";
var tickerInfoSchema = z47.tuple([
  z47.string(),
  // pair name
  z47.string(),
  // lastPrice
  z47.string(),
  // openPrice
  z47.string(),
  // high price
  z47.string(),
  // low price
  z47.string()
  // volume 24h
]).transform(([pairName, lastPrice, openPrice, highPrice, lowPrice, volume24h]) => ({
  pairName,
  lastPrice,
  openPrice,
  highPrice,
  lowPrice,
  volume24h
}));
var tickerInfoSchema_default = tickerInfoSchema;

// src/services/PriceFeed/ws/schemas/candleSchema.ts
import { z as z48 } from "zod";
var candleSchema = z48.tuple([
  z48.string(),
  // interval [FIVE, FIFTEEN, THIRTY, HOUR, HOUR4, DAY, WEEK]
  z48.string(),
  // pair ["ethusdf"]
  z48.number(),
  // timeStart [timestamp]
  z48.number(),
  // timeEnd [timestamp]
  z48.string(),
  // close
  z48.string(),
  // open
  z48.string(),
  // high
  z48.string(),
  // low
  z48.string()
  // volume
]).transform(
  ([interval, pair, timeStart, timeEnd, close, open, high, low, volume]) => ({
    interval,
    pair,
    timeStart,
    timeEnd,
    close,
    open,
    high,
    low,
    volume
  })
);
var candleSchema_default = candleSchema;

// src/services/PriceFeed/ws/schemas/priceSchema.ts
import { z as z49 } from "zod";
var priceSchema = z49.tuple([
  z49.number(),
  // unix timestamp
  z49.string(),
  // pair
  z49.number()
  // price
]).transform(([, pair, price]) => ({ pair, price }));
var priceSchema_default = priceSchema;

// src/services/PriceFeed/ws/schemas/allTickersSchema.ts
import { z as z50 } from "zod";
var allTickersSchema2 = z50.unknown().array().transform((tickers) => {
  const data = [...tickers];
  data.shift();
  const parsedData = tickerInfoSchema_default.array().parse(data);
  return parsedData.reduce((prev, pairData) => ({
    ...prev,
    [pairData.pairName]: pairData
  }), {});
});
var allTickersSchema_default = allTickersSchema2;

// src/services/PriceFeed/ws/PriceFeedSubscription.ts
var subscriptions = {
  [priceFeedSubscriptions_default.ALL_TICKERS]: {
    schema: allTickersSchema_default,
    payload: false
  },
  [priceFeedSubscriptions_default.TICKER]: {
    schema: z51.tuple([z51.number(), tickerInfoSchema_default]).transform(([, tickerInfo]) => tickerInfo),
    payload: true
  },
  [priceFeedSubscriptions_default.LAST_PRICE]: {
    schema: priceSchema_default,
    payload: true
  },
  [priceFeedSubscriptions_default.CANDLE]: {
    schema: candleSchema_default,
    payload: true
  }
};
var PriceFeedSubscription = class {
  id;
  callback;
  errorCallback;
  payload;
  ws;
  url;
  heartbeatInterval;
  type;
  // is used to make sure we do not need to renew ws subscription
  // we can not be sure that onclose event will recieve our code when we do `ws.close(4000)`
  // since sometimes it can be replaced with system one.
  // https://stackoverflow.com/questions/19304157/getting-the-reason-why-websockets-closed-with-close-code-1006
  isClosedIntentionally = false;
  onOpen;
  constructor(type, url, params, onOpen) {
    this.id = uuidv42();
    this.url = url;
    this.type = type;
    if ("payload" in params) {
      this.payload = params.payload;
    }
    this.callback = params.callback;
    this.errorCallback = params.errorCallback;
    this.onOpen = onOpen;
    this.init();
  }
  send(jsonObject) {
    if (this.ws?.readyState === WebSocket2.OPEN) {
      const jsonData = JSON.stringify(jsonObject);
      this.ws.send(jsonData);
    } else {
      setTimeout(() => {
        this.send(jsonObject);
      }, 50);
    }
  }
  isAlive = false;
  hearbeatIntervalId;
  setupHeartbeat() {
    const heartbeat = () => {
      if (this.isAlive) {
        this.isAlive = false;
      } else {
        this.isClosedIntentionally = false;
        this.clearHeartbeat();
        this.ws?.close(4e3);
      }
    };
    this.hearbeatIntervalId = setInterval(heartbeat, 15e3);
  }
  clearHeartbeat() {
    this.isAlive = false;
    clearInterval(this.hearbeatIntervalId);
  }
  init() {
    this.isClosedIntentionally = false;
    const { payload, url, type } = this;
    this.ws = new WebSocket2(
      `${url}/${type}${payload !== void 0 ? `/${payload.toString()}` : ""}`
    );
    this.ws.onopen = (e) => {
      this.isAlive = true;
      this.setupHeartbeat();
      if (this.onOpen !== void 0) {
        this.onOpen(e);
      }
    };
    this.ws.onmessage = (e) => {
      this.isAlive = true;
      const { data } = e;
      let dataString;
      if (typeof data === "string") {
        dataString = data;
      } else if (Buffer.isBuffer(data)) {
        dataString = data.toString();
      } else if (Array.isArray(data)) {
        dataString = Buffer.concat(data).toString();
      } else {
        dataString = Buffer.from(data).toString();
      }
      if (dataString === "pong")
        return;
      const json = JSON.parse(dataString);
      const subscription = subscriptions[type];
      const parseResult = subscription.schema.safeParse(json);
      if (!parseResult.success) {
        const errorsMessage = parseResult.error.errors.map((error2) => `[${error2.path.join(".")}] ${error2.message}`).join(", ");
        const error = new Error(`Can't recognize PriceFeed "${type}" subscription message "${dataString}": ${errorsMessage}`);
        if (this.errorCallback !== void 0) {
          this.errorCallback(error);
        } else
          throw error;
      } else {
        this.callback(parseResult.data);
      }
    };
    this.ws.onclose = () => {
      if (this.heartbeatInterval)
        clearInterval(this.heartbeatInterval);
      if (!this.isClosedIntentionally) {
        setTimeout(() => {
          this.init();
        }, 5e3);
      }
    };
    this.heartbeatInterval = setInterval(() => {
      this.send("heartbeat");
    }, 15e3);
  }
  kill() {
    this.isClosedIntentionally = true;
    this.ws?.close();
  }
};

// src/services/PriceFeed/ws/index.ts
var PriceFeedWS = class {
  subscriptions = {};
  url;
  basicAuth;
  constructor(url, basicAuth) {
    this.url = url;
    this.basicAuth = basicAuth;
  }
  get api() {
    const url = new URL(this.url);
    if (this.basicAuth) {
      url.username = this.basicAuth.username;
      url.password = this.basicAuth.password;
    }
    return url.toString();
  }
  subscribe(type, params, onOpen) {
    const sub = new PriceFeedSubscription(
      type,
      this.api,
      params,
      onOpen
    );
    this.subscriptions = {
      ...this.subscriptions,
      [type]: {
        ...this.subscriptions[type],
        [sub.id]: sub
      }
    };
    return {
      type: sub.type,
      id: sub.id,
      unsubscribe: () => {
        this.unsubscribe(sub.type, sub.id);
      }
    };
  }
  unsubscribe(subType, subId) {
    this.subscriptions[subType]?.[subId]?.kill();
    delete this.subscriptions[subType]?.[subId];
  }
};

// src/services/PriceFeed/index.ts
var PriceFeed = class {
  apiUrl;
  basicAuth;
  ws;
  get api() {
    return this.apiUrl;
  }
  constructor(apiUrl, basicAuth) {
    this.apiUrl = apiUrl;
    this.ws = new PriceFeedWS(this.wsUrl);
    this.basicAuth = basicAuth;
    this.getCandles = this.getCandles.bind(this);
    this.getAllTickers = this.getAllTickers.bind(this);
    this.getLeaderboard = this.getLeaderboard.bind(this);
    this.getStatisticsOverview = this.getStatisticsOverview.bind(this);
    this.getTopPairs = this.getTopPairs.bind(this);
    this.getWinners = this.getWinners.bind(this);
  }
  get basicAuthHeaders() {
    if (this.basicAuth) {
      return {
        Authorization: `Basic ${btoa(`${this.basicAuth.username}:${this.basicAuth.password}`)}`
      };
    }
    return {};
  }
  getCandles = (symbol, timeStart, timeEnd, interval, exchange = "all") => {
    const url = new URL(this.candlesUrl);
    url.searchParams.append("symbol", symbol);
    url.searchParams.append("timeStart", timeStart.toString());
    url.searchParams.append("timeEnd", timeEnd.toString());
    url.searchParams.append("interval", interval);
    url.searchParams.append("exchange", exchange);
    return fetchWithValidation3(
      url.toString(),
      candlesSchema_default,
      { headers: this.basicAuthHeaders }
    );
  };
  getAllTickers = () => {
    return fetchWithValidation3(
      `${this.tickersUrl}/all`,
      allTickersSchema,
      { headers: this.basicAuthHeaders }
    );
  };
  getLeaderboard = () => {
    return fetchWithValidation3(
      `${this.statisticsUrl}/futures/addresses`,
      leaderboardSchema,
      { headers: this.basicAuthHeaders }
    );
  };
  getStatisticsOverview = () => {
    return fetchWithValidation3(
      `${this.statisticsUrl}/overview?exchange=ALL`,
      statisticsOverviewSchema,
      { headers: this.basicAuthHeaders }
    );
  };
  getTopPairs = () => {
    return fetchWithValidation3(
      `${this.statisticsUrl}/top-pairs?exchange=ALL`,
      topPairsSchema,
      { headers: this.basicAuthHeaders }
    );
  };
  getWinners = () => {
    return fetchWithValidation3(
      `${this.statisticsUrl}/futures/winners`,
      winnersSchema,
      { headers: this.basicAuthHeaders }
    );
  };
  get wsUrl() {
    const url = new URL(this.apiUrl);
    const wsProtocol = url.protocol === "https:" ? "wss" : "ws";
    return `${wsProtocol}://${url.host + url.pathname}/api/v1`;
  }
  get candlesUrl() {
    return `${this.apiUrl}/api/v1/candles`;
  }
  get statisticsUrl() {
    return `${this.apiUrl}/api/v1/statistics`;
  }
  get tickersUrl() {
    return `${this.apiUrl}/api/v1/ticker`;
  }
};

// src/Unit/index.ts
import { simpleFetch } from "simple-typed-fetch";
import { BigNumber as BigNumber4 } from "bignumber.js";
var Unit = class {
  networkCode;
  baseCurrencyName;
  chainId;
  provider;
  blockchainService;
  aggregator;
  priceFeed;
  config;
  constructor(config) {
    if ("env" in config) {
      const staticConfig = envs[config.env];
      if (!staticConfig)
        throw new Error(`Invalid environment: ${config.env}. Available environments: ${Object.keys(envs).join(", ")}`);
      const chainConfig = chains[config.chainId];
      if (!chainConfig)
        throw new Error(`Invalid chainId: ${config.chainId}. Available chainIds: ${Object.keys(chains).join(", ")}`);
      const networkConfig = staticConfig.networks[config.chainId];
      if (!networkConfig)
        throw new Error(`Invalid chainId: ${config.chainId}. Available chainIds: ${Object.keys(staticConfig.networks).join(", ")}`);
      this.config = {
        chainId: config.chainId,
        nodeJsonRpc: networkConfig.rpc ?? chainConfig.rpc,
        services: {
          blockchainService: {
            http: networkConfig.api + networkConfig.services.blockchain.http
          },
          aggregator: {
            http: networkConfig.api + networkConfig.services.aggregator.http,
            ws: networkConfig.api + networkConfig.services.aggregator.ws
          },
          priceFeed: {
            api: networkConfig.api + networkConfig.services.priceFeed.all
          }
        }
      };
    } else {
      this.config = config;
    }
    const chainInfo = chains[config.chainId];
    if (!chainInfo)
      throw new Error("Chain info is required");
    this.chainId = config.chainId;
    this.networkCode = chainInfo.code;
    this.baseCurrencyName = chainInfo.baseCurrencyName;
    const intNetwork = parseInt(this.chainId, 10);
    if (Number.isNaN(intNetwork))
      throw new Error("Invalid chainId (not a number)" + this.chainId);
    this.provider = new ethers8.JsonRpcProvider(this.config.nodeJsonRpc, intNetwork);
    this.provider.pollingInterval = 1e3;
    this.blockchainService = new BlockchainService(
      this.config.services.blockchainService.http,
      this.config.basicAuth
    );
    this.aggregator = new Aggregator(
      this.config.services.aggregator.http,
      this.config.services.aggregator.ws,
      this.config.basicAuth
    );
    this.priceFeed = new PriceFeed(
      this.config.services.priceFeed.api,
      this.config.basicAuth
    );
  }
  // async makePositionCloseOrder(address: string, symbol: string, type: 'isolated'): Promise<CFDOrder>
  // async makePositionCloseOrder(address: string, symbol: string, type: 'cross'): Promise<CrossMarginCFDOrder>
  async makePositionCloseOrder(address, symbol, type) {
    const { instruments } = await simpleFetch(this.blockchainService.getCrossMarginInfo)();
    const instrumentInfo = instruments[symbol];
    if (instrumentInfo === void 0) {
      throw new Error(`Instrument ${symbol} not found. Available instruments: ${Object.keys(instruments).join(", ")}`);
    }
    const { statesByInstruments } = await simpleFetch(this.aggregator.getBalance)(address);
    const instrumentState = statesByInstruments[symbol];
    if (instrumentState === void 0) {
      throw new Error(`Instrument state ${symbol} not found. Available instruments: ${Object.keys(statesByInstruments).join(", ")}`);
    }
    const { position, currentPrice } = instrumentState;
    const { matcherAddress } = await simpleFetch(this.blockchainService.getInfo)();
    const { totalFee } = await this.calculateFee(symbol, position, type);
    const nonce = Date.now();
    const expiration = nonce + DEFAULT_EXPIRATION;
    const isShort = position < 0;
    return {
      senderAddress: address,
      matcherAddress,
      instrumentIndex: instrumentInfo.id,
      amount: position,
      price: currentPrice,
      matcherFee: totalFee.toNumber(),
      expiration,
      side: isShort ? "BUY" : "SELL",
      isPersonalSign: false
    };
  }
  async calculateFee(symbol, amount, type) {
    const feeAssetName = "USDT";
    const { assetToAddress } = await simpleFetch(this.blockchainService.getInfo)();
    const {
      FILL_CFD_ORDERS_TRADE_GAS_LIMIT
    } = await simpleFetch(this.blockchainService.getBaseLimits)();
    let feePercent;
    let symbolPrice;
    if (type === "isolated") {
      const CFDContracts = await simpleFetch(this.blockchainService.getCFDContracts)();
      const contractInfo = CFDContracts.find((c) => c.name === symbol);
      if (contractInfo === void 0) {
        throw new Error(`CFD contract ${symbol} not found`);
      }
      feePercent = contractInfo.feePercent;
      const CFDPrices = await simpleFetch(this.blockchainService.getCFDPrices)();
      if (!(symbol in CFDPrices))
        throw new Error(`CFD price ${symbol} not found`);
      symbolPrice = CFDPrices.prices[symbol];
    } else {
      const { instruments } = await simpleFetch(this.blockchainService.getCrossMarginInfo)();
      const instrumentInfo = instruments[symbol];
      if (instrumentInfo === void 0) {
        throw new Error(`Instrument ${symbol} not found`);
      }
      feePercent = instrumentInfo.feePercent;
      const CFDPrices = await simpleFetch(this.blockchainService.getCrossMarginCFDPrices)();
      if (!(symbol in CFDPrices))
        throw new Error(`CFD price ${symbol} not found`);
      symbolPrice = CFDPrices.prices[symbol];
    }
    if (symbolPrice === void 0)
      throw new Error(`Price for ${symbol} not found`);
    const gasPriceWei = await simpleFetch(this.blockchainService.getGasPriceWei)();
    const gasPriceGwei = ethers8.formatUnits(gasPriceWei, "gwei");
    const pricesWithQuoteAsset = await simpleFetch(this.blockchainService.getPricesWithQuoteAsset)();
    const baseCurrencyPriceInQuoteAsset = pricesWithQuoteAsset.prices[ethers8.ZeroAddress];
    if (baseCurrencyPriceInQuoteAsset === void 0)
      throw new Error(`Base currency ${this.baseCurrencyName} price not found. Available: ${Object.keys(pricesWithQuoteAsset).join(", ")}`);
    const feeAssetAddress = assetToAddress[feeAssetName];
    if (feeAssetAddress === void 0)
      throw new Error(`Fee asset ${feeAssetName} address not found`);
    const feeAssetPriceInQuoteAsset = pricesWithQuoteAsset.prices[feeAssetAddress];
    if (feeAssetPriceInQuoteAsset === void 0)
      throw new Error(`Fee asset ${feeAssetName} not found. Available: ${Object.keys(pricesWithQuoteAsset).join(", ")}`);
    const networkFee = calculateNetworkFee(
      gasPriceGwei.toString(),
      FILL_CFD_ORDERS_TRADE_GAS_LIMIT
    );
    const amountBN = new BigNumber4(amount);
    const priceForFee = new BigNumber4(symbolPrice);
    const networkFeeInQuoteAsset = new BigNumber4(networkFee).multipliedBy(baseCurrencyPriceInQuoteAsset).toString();
    const networkFeeInFeeAsset = new BigNumber4(networkFeeInQuoteAsset).multipliedBy(
      new BigNumber4(1).div(feeAssetPriceInQuoteAsset)
    ).toString();
    const fee = new BigNumber4(priceForFee).multipliedBy(amountBN).multipliedBy(feePercent).div(100);
    const totalFee = fee.plus(networkFeeInFeeAsset);
    return {
      networkFee,
      networkFeeInElt: networkFeeInQuoteAsset,
      networkFeeInFeeAsset,
      fee,
      totalFee
    };
  }
};

// src/Electra/index.ts
import { merge } from "merge-anything";
import { simpleFetch as simpleFetch2 } from "simple-typed-fetch";

// src/services/ReferralSystem/index.ts
var ReferralSystem_exports = {};
__export(ReferralSystem_exports, {
  ReferralSystem: () => ReferralSystem,
  schemas: () => schemas_exports7
});
import { fetchWithValidation as fetchWithValidation4 } from "simple-typed-fetch";

// src/services/ReferralSystem/schemas/index.ts
var schemas_exports7 = {};
__export(schemas_exports7, {
  accountDetailsSchema: () => accountDetailsSchema,
  accountReferralsSchema: () => accountReferralsSchema,
  aggregatedHistorySchema: () => aggregatedHistorySchema_default,
  errorSchema: () => errorSchema3,
  leaderboardSchema: () => leaderboardSchema2,
  linkSchema: () => linkSchema_default,
  subscribeToReferralErrorSchema: () => subscribeToReferralErrorSchema
});

// src/services/ReferralSystem/schemas/linkSchema.ts
import { z as z52 } from "zod";
var linkSchema = z52.object({
  referer: z52.string(),
  ref_link: z52.string(),
  option: z52.number()
});
var linkSchema_default = linkSchema;

// src/services/ReferralSystem/schemas/errorSchema.ts
import { z as z53 } from "zod";
var errorSchema3 = z53.object({
  status: z53.string(),
  message: z53.string()
});

// src/services/ReferralSystem/schemas/subscribeToReferralErrorSchema.ts
import { z as z54 } from "zod";
var subscribeToReferralErrorSchema = errorSchema3.extend({
  ref_link: z54.string().optional()
});

// src/services/ReferralSystem/schemas/aggregatedHistorySchema.ts
import { z as z55 } from "zod";
var aggregatedHistorySchema = z55.object({
  data: z55.array(z55.object({
    history_type: z55.string(),
    bonus_description: z55.string().nullable(),
    chain_type: z55.string(),
    chain_comp: z55.string(),
    chain_id: z55.number(),
    date_unix: z55.number(),
    date_time_local: z55.string(),
    date_time_utc: z55.string(),
    amount_token: z55.string(),
    amount_token_fmt: z55.number(),
    amount_usd: z55.string(),
    amount_usd_fmt: z55.number(),
    token_price: z55.string(),
    token_price_fmt: z55.number()
  })),
  pagination_info: z55.object({
    c_page: z55.number(),
    t_pages: z55.number()
  })
});
var aggregatedHistorySchema_default = aggregatedHistorySchema;

// src/services/ReferralSystem/schemas/accountDetailsSchema.ts
import { z as z56 } from "zod";
var pointsAdditionalSchema = z56.object({
  event_name: z56.string(),
  points: z56.number()
});
var accountDetailsSchema = z56.object({
  address: z56.string(),
  ref_link: z56.string(),
  rank: z56.number(),
  referrals_count: z56.number(),
  direct_referrals_count: z56.number(),
  points_total: z56.number(),
  points_trading_volume: z56.number(),
  points_network_trading_volume: z56.number(),
  network_trading_volume: z56.number(),
  points_additional: z56.array(pointsAdditionalSchema)
});

// src/services/ReferralSystem/schemas/accountReferralsSchema.ts
import { z as z58 } from "zod";

// src/services/ReferralSystem/schemas/paginationInfoSchema.ts
import { z as z57 } from "zod";
var paginationInfoSchema = z57.object({
  c_page: z57.number(),
  t_pages: z57.number()
});

// src/services/ReferralSystem/schemas/accountReferralsSchema.ts
var dataSchema = z58.object({
  referral: z58.string(),
  relative_level: z58.number(),
  volume: z58.number(),
  points: z58.number()
});
var accountReferralsSchema = z58.object({
  data: z58.array(dataSchema),
  pagination_info: paginationInfoSchema
});

// src/services/ReferralSystem/schemas/leaderboardSchema.ts
import { z as z59 } from "zod";
var dataSchema2 = z59.object({
  referral: z59.string(),
  referrals_count: z59.number(),
  points_total: z59.number(),
  points_referrals: z59.number(),
  points_additional: z59.number()
});
var leaderboardSchema2 = z59.object({
  pagination_info: paginationInfoSchema,
  data: z59.array(dataSchema2)
});

// src/services/ReferralSystem/index.ts
var ReferralSystem = class {
  apiUrl;
  get api() {
    return this.apiUrl;
  }
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
    this.subscribeToReferral = this.subscribeToReferral.bind(this);
    this.getAggregatedHistory = this.getAggregatedHistory.bind(this);
    this.getLeaderboard = this.getLeaderboard.bind(this);
    this.getAccountDetails = this.getAccountDetails.bind(this);
    this.getAccountReferrals = this.getAccountReferrals.bind(this);
  }
  subscribeToReferral = (payload) => fetchWithValidation4(
    `${this.apiUrl}/referer/subscribe2`,
    linkSchema_default,
    {
      headers: {
        "Content-type": "application/json"
      },
      method: "POST",
      body: JSON.stringify(payload)
    },
    subscribeToReferralErrorSchema
  );
  getAggregatedHistory = (refererAddress, chainId, types, itemPerPage, page) => {
    const queryParams = {
      n_per_page: itemPerPage,
      page,
      suppress_error: 1
    };
    if (chainId !== void 0) {
      queryParams["chain_id"] = chainId;
    }
    if (types !== void 0) {
      queryParams["history_filter"] = encodeURIComponent(types.join(","));
    }
    const queryString = Object.entries(queryParams).map(([k, v]) => `${k}=${v}`).join("&");
    return fetchWithValidation4(
      `${this.apiUrl}/referer/view/aggregated-history?${queryString}`,
      aggregatedHistorySchema_default,
      {
        headers: {
          "referer-address": refererAddress
        }
      },
      errorSchema3
    );
  };
  getLeaderboard = ({
    page = 1
  }) => {
    return fetchWithValidation4(
      `${this.apiUrl}/referer/futures/leaderboard?page=${page}`,
      leaderboardSchema2
    );
  };
  getAccountDetails = ({ address }) => {
    return fetchWithValidation4(
      `${this.apiUrl}/referer/futures/account-details?address=${address}`,
      accountDetailsSchema
    );
  };
  getAccountReferrals = ({ address, page = 1 }) => {
    return fetchWithValidation4(
      `${this.apiUrl}/referer/futures/account-referrals?address=${address}&page=${page}`,
      accountReferralsSchema
    );
  };
};

// src/Electra/index.ts
var Electra = class {
  env;
  units;
  referralSystem;
  constructor(envOrConfig = "production", overrides) {
    let config;
    if (typeof envOrConfig === "string") {
      const envConfig = envs[envOrConfig];
      if (!envConfig) {
        throw new Error(`Invalid environment: ${envOrConfig}. Available environments: ${Object.keys(envs).join(", ")}`);
      }
      this.env = envOrConfig;
      config = {
        marginMode: envConfig.marginMode,
        referralAPI: envConfig.referralAPI,
        networks: Object.entries(envConfig.networks).map(([chainId, networkConfig]) => {
          if (!isValidChainId_default(chainId))
            throw new Error(`Invalid chainId: ${chainId}`);
          const chainConfig = chains[chainId];
          if (!chainConfig) {
            throw new Error(`Chain config not found: ${chainId}. Available chains: ${Object.keys(chains).join(", ")}`);
          }
          return {
            env: envOrConfig,
            chainId,
            api: networkConfig.api,
            nodeJsonRpc: networkConfig.rpc ?? chainConfig.rpc,
            services: {
              blockchainService: {
                http: networkConfig.api + networkConfig.services.blockchain.http
              },
              aggregator: {
                http: networkConfig.api + networkConfig.services.aggregator.http,
                ws: networkConfig.api + networkConfig.services.aggregator.ws
              },
              priceFeed: {
                api: networkConfig.api + networkConfig.services.priceFeed.all
              }
            }
          };
        }).reduce((acc, cur) => {
          acc[cur.chainId] = cur;
          return acc;
        }, {})
      };
      if (overrides) {
        config = merge(config, overrides);
      }
    } else {
      config = envOrConfig;
    }
    this.referralSystem = new ReferralSystem(config.referralAPI);
    this.units = Object.entries(config.networks).reduce((acc, [chainId, networkConfig]) => {
      if (!isValidChainId_default(chainId))
        throw new Error(`Invalid chainId: ${chainId}`);
      const chainConfig = chains[chainId];
      if (!chainConfig)
        throw new Error(`Chain config not found: ${chainId}`);
      const unit = new Unit({
        // env: networkConfig.env,
        chainId,
        // api: networkConfig.api,
        nodeJsonRpc: networkConfig.nodeJsonRpc,
        services: networkConfig.services
      });
      return {
        ...acc,
        [chainId]: unit
      };
    }, {});
  }
  get unitsArray() {
    return Object.entries(this.units).map(([, unit]) => unit);
  }
  getUnit(networkCodeOrChainId) {
    let unit;
    if (isValidChainId_default(networkCodeOrChainId)) {
      unit = this.units[networkCodeOrChainId];
    } else {
      unit = this.unitsArray.find((u) => u.networkCode === networkCodeOrChainId);
    }
    if (!unit) {
      throw new Error(
        `Invalid network code: ${networkCodeOrChainId}. Available network codes: ${this.unitsArray.map((u) => u.networkCode).join(", ")}`
      );
    }
    return unit;
  }
  getSiblingsOf(chainId) {
    return this.unitsArray.filter((unit) => unit.chainId !== chainId);
  }
  async getPairs(...params) {
    const result = {};
    await Promise.all(this.unitsArray.map(async (unit) => {
      const pairs = await simpleFetch2(unit.aggregator.getPairsList)(...params);
      pairs.forEach((pair) => {
        result[pair] = [
          ...result[pair] ?? [],
          unit.chainId
        ];
      });
    }));
    return result;
  }
};

// src/services/index.ts
var services_exports = {};
__export(services_exports, {
  aggregator: () => Aggregator_exports,
  blockchainService: () => BlockchainService_exports,
  priceFeed: () => PriceFeed_exports,
  referralSystem: () => ReferralSystem_exports
});

// src/crypt/index.ts
var crypt_exports = {};
__export(crypt_exports, {
  signCFDOrder: () => signIsolatedMarginCFDOrder_default,
  signCancelOrder: () => signCancelOrder_default,
  signCancelOrderPersonal: () => signCancelOrderPersonal_default,
  signCrossMarginCFDOrder: () => signCrossMarginCFDOrder_default
});

// src/crypt/signCancelOrder.ts
import { ethers as ethers10 } from "ethers";

// src/config/eip712DomainData.json
var eip712DomainData_default = {
  name: "Electra",
  version: "1",
  salt: "0x5792f7333c35db190e30acc144f049fd15b24f552c0010b8b3e06f9105c37c5a"
};

// src/crypt/getDomainData.ts
var EIP712Domain = eip712DomainSchema_default.parse(eip712DomainData_default);
function removeUndefined(obj) {
  const newObj = {};
  for (const [key, value] of Object.entries(obj)) {
    if (value !== void 0) {
      newObj[key] = value;
    }
  }
  return newObj;
}
var getDomainData = (chainId) => ({
  ...removeUndefined(EIP712Domain),
  chainId
});
var getDomainData_default = getDomainData;

// src/crypt/signCancelOrderPersonal.ts
import { ethers as ethers9 } from "ethers";
var signCancelOrderPersonal = async (cancelOrderRequest, signer) => {
  const types = ["string", "string", "address"];
  const message = ethers9.solidityPackedKeccak256(
    types,
    ["cancelOrder", cancelOrderRequest.id, cancelOrderRequest.senderAddress]
  );
  const signature = await signer.signMessage(ethers9.getBytes(message));
  return ethers9.Signature.from(signature).serialized;
};
var signCancelOrderPersonal_default = signCancelOrderPersonal;

// src/crypt/signCancelOrder.ts
var signCancelOrder = async (senderAddress, id, usePersonalSign, signer, chainId, isFromDelegate) => {
  const cancelOrderRequest = {
    id,
    senderAddress,
    isPersonalSign: usePersonalSign,
    isFromDelegate
  };
  const signature = usePersonalSign ? await signCancelOrderPersonal_default(cancelOrderRequest, signer) : await signer.signTypedData(
    getDomainData_default(chainId),
    cancelOrderTypes_default,
    cancelOrderRequest
  );
  const fixedSignature = ethers10.Signature.from(signature).serialized;
  const signedCancelOrderReqeust = {
    ...cancelOrderRequest,
    signature: fixedSignature
  };
  return signedCancelOrderReqeust;
};
var signCancelOrder_default = signCancelOrder;

// src/crypt/signIsolatedMarginCFDOrder.ts
import { BigNumber as BigNumber5 } from "bignumber.js";
import { ethers as ethers13 } from "ethers";

// src/crypt/signIsolatedMarginCFDOrderPersonal.ts
import { ethers as ethers11 } from "ethers";
var signIsolatedMarginCFDOrderPersonal = async (order, signer) => {
  const message = ethers11.solidityPackedKeccak256(
    [
      "string",
      "address",
      "address",
      "address",
      "uint64",
      "uint64",
      "uint64",
      "uint64",
      "uint64",
      "uint8"
    ],
    [
      "order",
      order.senderAddress,
      order.matcherAddress,
      order.instrumentAddress,
      order.amount,
      order.price,
      order.matcherFee,
      order.nonce,
      order.expiration,
      order.buySide
    ]
  );
  const signature = await signer.signMessage(ethers11.getBytes(message));
  return ethers11.Signature.from(signature).serialized;
};
var signIsolatedMarginCFDOrderPersonal_default = signIsolatedMarginCFDOrderPersonal;

// src/crypt/hashIsolatedMarginCFDOrder.ts
import { ethers as ethers12 } from "ethers";
var hashIsolatedMarginCFDOrder = (order) => ethers12.solidityPackedKeccak256(
  [
    "uint8",
    "address",
    "address",
    "address",
    "uint64",
    "uint64",
    "uint64",
    "uint64",
    "uint64",
    "uint8"
  ],
  [
    "0x03",
    order.senderAddress,
    order.matcherAddress,
    order.instrumentAddress,
    order.amount,
    order.price,
    order.matcherFee,
    order.nonce,
    order.expiration,
    order.buySide === 1 ? "0x01" : "0x00"
  ]
);
var hashIsolatedMarginCFDOrder_default = hashIsolatedMarginCFDOrder;

// src/constants/cfdOrderTypes.ts
var ISOLATED_MARGIN_CFD_ORDER_TYPES = {
  CFDOrder: [
    { name: "senderAddress", type: "address" },
    { name: "matcherAddress", type: "address" },
    { name: "instrumentAddress", type: "address" },
    { name: "amount", type: "uint64" },
    { name: "price", type: "uint64" },
    { name: "matcherFee", type: "uint64" },
    { name: "nonce", type: "uint64" },
    { name: "expiration", type: "uint64" },
    { name: "buySide", type: "uint8" }
  ]
};
var CROSS_MARGIN_CFD_ORDER_TYPES = {
  CFDOrder: [
    { name: "senderAddress", type: "address" },
    { name: "matcherAddress", type: "address" },
    { name: "instrumentIndex", type: "uint16" },
    { name: "amount", type: "uint96" },
    { name: "price", type: "uint80" },
    { name: "matcherFee", type: "uint64" },
    { name: "expiration", type: "uint64" },
    { name: "buySide", type: "uint8" }
  ]
};

// src/crypt/signIsolatedMarginCFDOrder.ts
var signIsolatedMarginCFDOrder = async (instrumentAddress, side, price, amount, matcherFee, senderAddress, matcherAddress, usePersonalSign, signer, chainId, stopPrice, isFromDelegate) => {
  const nonce = Date.now();
  const expiration = nonce + DEFAULT_EXPIRATION;
  const order = {
    senderAddress,
    matcherAddress,
    instrumentAddress,
    amount: Number(normalizeNumber(
      amount,
      INTERNAL_PROTOCOL_PRECISION,
      BigNumber5.ROUND_FLOOR
    )),
    price: Number(normalizeNumber(
      price,
      INTERNAL_PROTOCOL_PRECISION,
      BigNumber5.ROUND_FLOOR
    )),
    matcherFee: Number(normalizeNumber(
      matcherFee,
      INTERNAL_PROTOCOL_PRECISION,
      BigNumber5.ROUND_CEIL
      // ROUND_CEIL because we don't want get "not enough fee" error
    )),
    nonce,
    expiration,
    buySide: side === "BUY" ? 1 : 0,
    stopPrice: stopPrice !== void 0 ? new BigNumber5(stopPrice).toNumber() : void 0,
    isPersonalSign: usePersonalSign,
    isFromDelegate
  };
  const signature = usePersonalSign ? await signIsolatedMarginCFDOrderPersonal_default(order, signer) : await signer.signTypedData(
    getDomainData_default(chainId),
    ISOLATED_MARGIN_CFD_ORDER_TYPES,
    order
  );
  const fixedSignature = ethers13.Signature.from(signature).serialized;
  const signedOrder = {
    ...order,
    id: hashIsolatedMarginCFDOrder_default(order),
    signature: fixedSignature
  };
  return signedOrder;
};
var signIsolatedMarginCFDOrder_default = signIsolatedMarginCFDOrder;

// src/crypt/signCrossMarginCFDOrder.ts
import { BigNumber as BigNumber6 } from "bignumber.js";
import { ethers as ethers16 } from "ethers";

// src/crypt/signCrossMarginCFDOrderPersonal.ts
import { ethers as ethers14 } from "ethers";
var signCrossMarginCFDOrderPersonal = async (order, signer) => {
  const message = ethers14.solidityPackedKeccak256(
    [
      "string",
      "address",
      "address",
      "uint16",
      "uint96",
      "uint80",
      "uint64",
      "uint64",
      "uint8"
    ],
    [
      "order",
      order.senderAddress,
      order.matcherAddress,
      order.instrumentIndex,
      order.amount,
      order.price,
      order.matcherFee,
      order.expiration,
      order.buySide
    ]
  );
  const signature = await signer.signMessage(ethers14.getBytes(message));
  return ethers14.Signature.from(signature).serialized;
};
var signCrossMarginCFDOrderPersonal_default = signCrossMarginCFDOrderPersonal;

// src/crypt/hashCrossMarginCFDOrder.ts
import { ethers as ethers15 } from "ethers";
var hashCrossMarginCFDOrder = (order) => ethers15.solidityPackedKeccak256(
  [
    "uint8",
    "address",
    "address",
    "uint16",
    "uint96",
    "uint80",
    "uint64",
    "uint64",
    "uint8"
  ],
  [
    "0x03",
    order.senderAddress,
    order.matcherAddress,
    order.instrumentIndex,
    order.amount,
    order.price,
    order.matcherFee,
    order.expiration,
    order.buySide === 1 ? "0x01" : "0x00"
  ]
);
var hashCrossMarginCFDOrder_default = hashCrossMarginCFDOrder;

// src/crypt/signCrossMarginCFDOrder.ts
var signCrossMarginCFDOrder = async (instrumentIndex, side, price, amount, matcherFee, senderAddress, matcherAddress, usePersonalSign, signer, chainId, stopPrice, leverage, isFromDelegate) => {
  const nonce = Date.now();
  const expiration = nonce + DEFAULT_EXPIRATION;
  const order = {
    senderAddress,
    matcherAddress,
    instrumentIndex,
    amount: Number(normalizeNumber(
      amount,
      INTERNAL_PROTOCOL_PRECISION,
      BigNumber6.ROUND_FLOOR
    )),
    price: Number(normalizeNumber(
      price,
      INTERNAL_PROTOCOL_PRECISION,
      BigNumber6.ROUND_FLOOR
    )),
    matcherFee: Number(normalizeNumber(
      matcherFee,
      INTERNAL_PROTOCOL_PRECISION,
      BigNumber6.ROUND_CEIL
      // ROUND_CEIL because we don't want get "not enough fee" error
    )),
    expiration,
    buySide: side === "BUY" ? 1 : 0,
    stopPrice: stopPrice !== void 0 ? new BigNumber6(stopPrice).toNumber() : void 0,
    leverage: leverage !== void 0 ? leverage : void 0,
    isPersonalSign: usePersonalSign,
    isFromDelegate
  };
  const signature = usePersonalSign ? await signCrossMarginCFDOrderPersonal_default(order, signer) : await signer.signTypedData(
    getDomainData_default(chainId),
    CROSS_MARGIN_CFD_ORDER_TYPES,
    order
  );
  const fixedSignature = ethers16.Signature.from(signature).serialized;
  const signedOrder = {
    ...order,
    id: hashCrossMarginCFDOrder_default(order),
    signature: fixedSignature
  };
  return signedOrder;
};
var signCrossMarginCFDOrder_default = signCrossMarginCFDOrder;

// src/index.ts
BigNumber7.config({ EXPONENTIAL_AT: 1e9 });
export {
  APPROVE_ERC20_GAS_LIMIT,
  DEFAULT_EXPIRATION,
  DEFAULT_GAS_LIMIT,
  DEPOSIT_ERC20_GAS_LIMIT,
  DEPOSIT_ETH_GAS_LIMIT,
  Electra,
  FILL_ORDERS_GAS_LIMIT,
  GOVERNANCE_GET_REWARD_GAS_LIMIT,
  GOVERNANCE_STAKE_GAS_LIMIT,
  GOVERNANCE_UNSTAKE_GAS_LIMIT,
  GOVERNANCE_VOTE_GAS_LIMIT,
  HistoryTransactionStatus,
  INTERNAL_PROTOCOL_PRECISION,
  NATIVE_CURRENCY_PRECISION,
  SupportedChainId,
  Unit,
  VOTE_ERC20_GAS_LIMIT,
  WITHDRAW_GAS_LIMIT,
  cancelOrderTypes_default as cancelOrderTypes,
  config_exports as config,
  crypt_exports as crypt,
  developmentChains,
  networkCodes_default as networkCodes,
  orderSides,
  orderStatuses_default as orderStatuses,
  productionChains,
  services_exports as services,
  subOrderStatuses_default as subOrderStatuses,
  utils_exports as utils
};
//# sourceMappingURL=index.js.map